export const GLOSSARY = [
    {
       "key":1,
       "value":"10Base-T",
       "description":"Part of the original IEEE 802.3 standard, 10Base-T is the Ethernet specification of 10 Mbps baseband that uses two pairs of twisted-pair, category 3, 4, or 5 cabling—using one pair to send data and the other to receive. 10Base-T has a distance limit of about 100 meters per segment. See also: Ethernet and IEEE 802.3."
    },
    {
       "key":2,
       "value":"100Base-T",
       "description":"Based on the IEEE 802.3u standard, 100Base-T is the Fast Ethernet specifica- tion of 100 Mbps baseband that uses UTP wiring. 100Base-T sends link pulses (containing more information than those used in 10Base-T) over the network when no traffic is present. See also: 10Base-T, Fast Ethernet, and, IEEE 802.3."
    },
    {
       "key":3,
       "value":"100Base-TX",
       "description":"Based on the IEEE 802.3u standard, 100Base-TX is the 100 Mbps baseband Fast Ethernet specification that uses two pairs of UTP or STP wiring. The first pair of wires receives data; the second pair sends data. To ensure correct signal timing, a 100Base-TX segment cannot be longer than 100 meters."
    },
    {
       "key":4,
       "value":"A&B bit signaling",
       "description":"Used in T1 transmission facilities and sometimes called \u002724th channel signaling.\u0027 Each of the 24 T1 subchannels in this procedure uses one bit of every sixth frame to send supervisory signaling information."
    },
    {
       "key":5,
       "value":"AAA",
       "description":"Authentication, authorization, and accounting: A system developed by Cisco to pro- vide network security. See also: authentication, authorization, and accounting."
    },
    {
       "key":6,
       "value":"AAL",
       "description":"ATM Adaptation Layer: A service-dependent sublayer of the Data Link layer that accepts data from other applications and brings it to the ATM layer in 48-byte ATM pay- load segments. CS and SAR are the two sublayers that form AALs. Currently, the four types of AAL recommended by the ITU-T are AAL1, AAL2, AAL3/4, and AAL5. AALs are dif- ferentiated by the source-destination timing they use, whether they are CBR or VBR, and whether they are used for connection-oriented or connectionless mode data transmission. See also: AAL1, AAL2, AAL3/4, AAL5, ATM, and ATM layer."
    },
    {
       "key":7,
       "value":"AAL1",
       "description":"ATM Adaptation Layer 1: One of four AALs recommended by the ITU-T, it is used for connection-oriented, time-sensitive services that need constant bit rates, such as isochro- nous traffic and uncompressed video. See also: AAL."
    },
    {
       "key":8,
       "value":"AAL2",
       "description":"ATM Adaptation Layer 2: One of four AALs recommended by the ITU-T, it is used for connection-oriented services that support a variable bit rate, such as compressed voice traffic. See also: AAL."
    },
    {
       "key":9,
       "value":"AAL3/4",
       "description":"ATM Adaptation Layer 3/4: One of four AALs (a product of two initially distinct layers) recommended by the ITU-T, supporting both connectionless and connection-oriented links. Its primary use is in sending SMDS packets over ATM networks. See also: AAL."
    },
    {
       "key":10,
       "value":"AAL5",
       "description":"ATM Adaptation Layer 5: One of four AALs recommended by the ITU-T, it is used to support connection-oriented VBR services primarily to transfer classical IP over ATM and LANE traffic. This least complex of the AAL recommendations uses SEAL, offering lower bandwidth costs and simpler processing requirements but also providing reduced bandwidth and error-recovery capacities. See also: AAL."
    },
    {
       "key":11,
       "value":"AARP",
       "description":"AppleTalk Address Resolution Protocol: The protocol in an AppleTalk stack that maps Data Link addresses to Network addresses."
    },
    {
       "key":12,
       "value":"AARP probe packets",
       "description":"Packets sent by the AARP to determine whether a given node ID is being used by another node in a nonextended AppleTalk network. If the node ID is not in use, the sending node appropriates that node\u0027s ID. If the node ID is in use, the send- ing node will select a different ID and then send out more AARP probe packets. See also: AARP."
    },
    {
       "key":13,
       "value":"ABM",
       "description":"Asynchronous Balanced Mode: When two stations can initiate a transmission, ABM is an HDLC (or one of its derived protocols) communication technology that supports peer- oriented, point-to-point communications between both stations."
    },
    {
       "key":14,
       "value":"ABR",
       "description":"Area border router: An OSPF router that is located on the border of one or more OSPF areas. ABRs are used to connect OSPF areas to the OSPF backbone area."
    },
    {
       "key":15,
       "value":"access layer",
       "description":"One of the layers in Cisco\u0027s three-layer hierarchical model. The access layer provides users with access to the internetwork."
    },
    {
       "key":16,
       "value":"access link",
       "description":"A link that is used with switches and is part of only one virtual LAN (VLAN). Trunk links carry information from multiple VLANs."
    },
    {
       "key":17,
       "value":"access list",
       "description":"A set of test conditions that is kept by routers and determines \u0027interesting traffic\u0027 to and from the router for various services on the network."
    },
    {
       "key":18,
       "value":"access method",
       "description":"The manner in which network devices approach gaining access to the network itself."
    },
    {
       "key":19,
       "value":"access port",
       "description":"Configuration on a layer 2 switch port that sends and receives information about one VLAN only."
    },
    {
       "key":20,
       "value":"access rate",
       "description":"Defines the bandwidth rate of the circuit. For example, the access rate of a T1 circuit is 1.544 Mbps. In Frame Relay and other technologies, there may be a fractional T1 connection—256 Kbps, for example—however, the access rate and clock rate are still 1.544 Mbps."
    },
    {
       "key":21,
       "value":"access server",
       "description":"Also known as a network access server, it uses a communications process connecting asynchronous devices to a LAN or WAN through network and terminal emula- tion software, providing synchronous or asynchronous routing of supported protocols."
    },
    {
       "key":22,
       "value":"accounting",
       "description":"One of the three components in AAA. Accounting provides auditing and logging functionalities to the security model."
    },
    {
       "key":23,
       "value":"acknowledgment",
       "description":"Verification sent from one network device to another signifying that an event has occurred. May be abbreviated as ACK. Contrast with: NAK."
    },
    {
       "key":24,
       "value":"ACR",
       "description":"Allowed cell rate: A designation defined by the ATM Forum for managing ATM traffic. Dynamically controlled using congestion control measures, the ACR varies between the minimum cell rate (MCR) and the peak cell rate (PCR). See also: MCR and PCR."
    },
    {
       "key":25,
       "value":"active monitor",
       "description":"The mechanism used to manage a token ring. The network node with the highest MAC address on the ring becomes the active monitor and is responsible for manage- ment tasks such as preventing loops and ensuring that tokens are not lost."
    },
    {
       "key":26,
       "value":"active state",
       "description":"In regard to an EIGRP routing table, a route will be in active state when a router is undergoing a route convergence."
    },
    {
       "key":27,
       "value":"address learning",
       "description":"Used with transparent bridges to learn the hardware addresses of all devices on a network. The switch then filters the network with the known hardware (MAC) addresses."
    },
    {
       "key":28,
       "value":"address mapping",
       "description":"By translating network addresses from one format to another, this methodology permits different protocols to operate interchangeably."
    },
    {
       "key":29,
       "value":"address mask",
       "description":"A bit combination descriptor identifying which portion of an address refers to the network or subnet and which part refers to the host. Sometimes simply called the mask. See also: subnet mask."
    },
    {
       "key":30,
       "value":"address resolution",
       "description":"The process used for resolving differences between computer address- ing schemes. Address resolution typically defines a method for tracing Network layer (layer 3) addresses to Data Link layer (layer 2) addresses. See also: address mapping."
    },
    {
       "key":31,
       "value":"adjacency",
       "description":"The relationship made to exchange routing information between defined neigh- boring routers and end nodes using a common media segment."
    },
    {
       "key":32,
       "value":"administrative distance (AD)",
       "description":"A number between 0 and 255 that expresses the level of trustworthiness of a routing information source. The lower the number, the higher the integrity rating."
    },
    {
       "key":33,
       "value":"administrative weight",
       "description":"A value designated by a network administrator to rate the prefer- ence given to a network link. It is one of four link metrics exchanged by PTSPs to test ATM network resource availability."
    },
    {
       "key":34,
       "value":"ADSU",
       "description":"ATM data service unit: The terminal adapter used to connect to an ATM network through an HSSI-compatible mechanism. See also: DSU."
    },
    {
       "key":35,
       "value":"advertising",
       "description":"The process whereby routing or service updates are transmitted at given intervals, allowing other routers on the network to maintain a record of viable routes."
    },
    {
       "key":36,
       "value":"AEP",
       "description":"AppleTalk Echo Protocol: A test for connectivity between two AppleTalk nodes where one node sends a packet to another and receives an echo, or copy, in response."
    },
    {
       "key":37,
       "value":"AFI",
       "description":"Authority and Format Identifier: The part of an NSAP ATM address that delineates the type and format of the IDI section of an ATM address."
    },
    {
       "key":38,
       "value":"AFP",
       "description":"AppleTalk Filing Protocol: A Presentation layer protocol, supporting AppleShare and Mac OS File Sharing, that permits users to share files and applications on a server."
    },
    {
       "key":39,
       "value":"agents",
       "description":"Typically defined with SNMP to capture and send information to an NMS station."
    },
    {
       "key":40,
       "value":"AIP",
       "description":"ATM Interface Processor: Supporting AAL3/4 and AAL5, this interface for Cisco 7000 series routers minimizes performance bottlenecks at the UNI. See also: AAL3/4 and AAL5."
    },
    {
       "key":41,
       "value":"algorithm",
       "description":"A set of rules or processes used to solve a problem. In networking, algorithms are typically used for finding the best route for traffic from a source to its destination."
    },
    {
       "key":42,
       "value":"alignment error",
       "description":"An error occurring in Ethernet networks indicating that a received frame has extra bits—that is, a number not divisible by eight. Alignment errors are generally the result of frame damage caused by collisions."
    },
    {
       "key":43,
       "value":"all-routes explorer packet",
       "description":"An explorer packet that can move across an entire SRB network, tracing all possible paths to a given destination. Also known as an all-rings explorer packet. See also: explorer packet, local explorer packet, and spanning explorer packet."
    },
    {
       "key":44,
       "value":"AM",
       "description":"Amplitude modulation: A modulation method that represents information by varying the amplitude of the carrier signal. See also: modulation."
    },
    {
       "key":45,
       "value":"AMI",
       "description":"Alternate Mark Inversion: A line-code type on T1 and E1 circuits that shows zeros as 01 during each bit cell and ones as 11 or 00, alternately, during each bit cell. The send- ing device must maintain ones-density in AMI but not independently of the data stream. Also known as binary-coded, alternate mark inversion. Contrast with: B8ZS. See also: ones density."
    },
    {
       "key":46,
       "value":"amplitude",
       "description":"An analog or digital waveform\u0027s highest value."
    },
    {
       "key":47,
       "value":"analog transmission",
       "description":"Signal messaging whereby information is represented by various combinations of signal amplitude, frequency, and phase."
    },
    {
       "key":48,
       "value":"ANSI",
       "description":"American National Standards Institute: The organization of corporate, government, and volunteer members that coordinates standards-related activities, approves US national standards, and develops US positions in international standards organizations. ANSI assists in the creation of international and US standards in disciplines such as communications, networking, and a variety of technical fields. It publishes over 13,000 standards for engi- neered products and technologies ranging from screw threads to networking protocols. ANSI is a member of the International Electrotechnical Commission (IEC) and Interna- tional Organization for Standardization (ISO)."
    },
    {
       "key":49,
       "value":"anycast",
       "description":"An ATM address that can be shared by more than one end system, allowing requests to be routed to a node that provides a particular service. In IPv6, anycast is referred to as \u0027one-to-many.\u0027 Multiple router interfaces have the same IPv6 unicast address, and routers deliver the packets to the closest interface."
    },
    {
       "key":50,
       "value":"AppleTalk",
       "description":"Currently in two versions, the group of communication protocols designed by Apple Computer for use in Macintosh environments. The earlier Phase 1 protocols support one physical network with only one network number that resides in one zone. The later Phase 2 protocols support more than one logical network on a single physical network, allowing networks to exist in more than one zone. See also: zone."
    },
    {
       "key":51,
       "value":"Application layer",
       "description":"Layer 7 of the OSI reference network model, supplying services to application procedures (such as electronic mail and file transfer) that are outside the OSI model. This layer chooses and determines the availability of communicating partners along with the resources necessary to make the connection, coordinates partnering applications, and forms a consensus on procedures for controlling data integrity and error recovery. See also: Data Link layer, Network layer, Physical layer, Presentation layer, Session layer, and Transport layer."
    },
    {
       "key":52,
       "value":"ARA",
       "description":"AppleTalk Remote Access: A protocol for Macintosh users establishing their access to resources and data from a remote AppleTalk location."
    },
    {
       "key":53,
       "value":"area",
       "description":"A logical, rather than physical, set of segments (based on CLNS, DECnet, or OSPF) along with their attached devices. Areas are commonly connected to others using routers to create a single autonomous system. See also: AS."
    },
    {
       "key":54,
       "value":"area border router (ABR)",
       "description":"Term for a router configured with OSPF with interfaces in more than one OSPF area. See also ABR."
    },
    {
       "key":55,
       "value":"ARM",
       "description":"Asynchronous Response Mode: An HDLC communication mode using one primary station and at least one additional station. Transmission can be initiated from either the pri- mary unit or one of the secondary units."
    },
    {
       "key":56,
       "value":"ARP",
       "description":"Address Resolution Protocol: Defined in RFC 826, the protocol that traces IP addresses to MAC addresses. See also: RARP."
    },
    {
       "key":57,
       "value":"AS",
       "description":"Autonomous system: A group of networks under mutual administration that share the same routing methodology. Autonomous systems are subdivided by areas and must be assigned an individual 16-bit number by the IANA. See also: area."
    },
    {
       "key":58,
       "value":"AS path prepending",
       "description":"The use of route maps in BGP to lengthen the autonomous system path by adding false ASNs."
    },
    {
       "key":59,
       "value":"ASBR",
       "description":"Autonomous system boundary router: An area border router placed between an OSPF autonomous system and a non-OSPF network that operates both OSPF and an addi- tional routing protocol, such as RIP. ASBRs must be located in a non-stub OSPF area. See also: ABR, non-stub area, and OSPF."
    },
    {
       "key":60,
       "value":"ASCII",
       "description":"American Standard Code for Information Interchange: An 8-bit code for representing characters, consisting of 7 data bits plus 1 parity bit."
    },
    {
       "key":61,
       "value":"ASIC",
       "description":"Application-specific integrated circuit: An integrated circuit (IC) customized for a particular use. Used in layer 2 switches to make filtering decisions. The ASIC looks in the filter table of MAC addresses and determines which port the destination hardware address of a received hardware address is destined for. The frame will be allowed to traverse only that one segment. If the hardware address is unknown, the frame is forwarded out all ports."
    },
    {
       "key":62,
       "value":"ASN.1",
       "description":"Abstract Syntax Notation One: An OSI language used to describe types of data that is independent of computer structures and depicting methods. Described by ISO International Standard 8824."
    },
    {
       "key":63,
       "value":"ASP",
       "description":"AppleTalk Session Protocol: A protocol employing ATP to establish, maintain, and tear down sessions as well as sequence requests. See also: ATP."
    },
    {
       "key":64,
       "value":"AST",
       "description":"Automatic Spanning Tree: A function that supplies one path for spanning explorer frames traveling from one node in the network to another, supporting the automatic reso- lution of spanning trees in SRB networks. AST is based on the IEEE 802.1d standard. See also: IEEE 802.1 and SRB."
    },
    {
       "key":65,
       "value":"asynchronous transmission",
       "description":"Digital signals sent without precise timing, usually with different frequencies and phase relationships. Asynchronous transmissions generally enclose individual characters in control bits (called start and stop bits) that show the beginning and end of each character. Contrast with: isochronous transmission and syn- chronous transmission."
    },
    {
       "key":66,
       "value":"ATCP",
       "description":"AppleTalk Control Program: The protocol for establishing and configuring Apple- Talk over PPP, defined in RFC 1378. See also: PPP."
    },
    {
       "key":67,
       "value":"ATDM",
       "description":"Asynchronous time-division multiplexing: A technique for sending information, it differs from normal TDM in that the time slots are assigned when necessary rather than preassigned to certain transmitters. Contrast with: FDM, statistical multiplexing, and TDM."
    },
    {
       "key":68,
       "value":"ATG",
       "description":"Address Translation Gateway: The mechanism within Cisco DECnet routing soft- ware that enables routers to route multiple, independent DECnet networks and to establish a user-designated address translation for chosen nodes between networks."
    },
    {
       "key":69,
       "value":"ATM",
       "description":"Asynchronous Transfer Mode: The international standard, identified by fixed-length 53-byte cells, for transmitting cells in multiple service systems, such as voice, video, or data. Transit delays are reduced because the fixed-length cells permit processing to occur in the hardware. ATM is designed to maximize the benefits of high-speed transmission media, such as SONET, E3, and T3."
    },
    {
       "key":70,
       "value":"ATM ARP server",
       "description":"A device that supplies logical subnets running classical IP over ATM with address-resolution services."
    },
    {
       "key":71,
       "value":"ATM endpoint",
       "description":"The initiating or terminating connection in an ATM network. ATM end- points include servers, workstations, ATM-to-LAN switches, and ATM routers."
    },
    {
       "key":72,
       "value":"ATM Forum",
       "description":"The international organization founded jointly by Northern Telecom, Sprint, Cisco Systems, and NET/ADAPTIVE in 1991 to develop and promote standards-based implementation agreements for ATM technology. The ATM Forum broadens official stan- dards developed by ANSI and ITU-T and creates implementation agreements before official standards are published."
    },
    {
       "key":73,
       "value":"ATM layer",
       "description":"A sublayer of the Data Link layer in an ATM network that is service indepen- dent. To create standard 53-byte ATM cells, the ATM layer receives 48-byte segments from the AAL and attaches a 5-byte header to each. These cells are then sent to the Physical layer for transmission across the physical medium. See also: AAL."
    },
    {
       "key":74,
       "value":"ATMM",
       "description":"ATM Management: A procedure that runs on ATM switches, managing rate enforcement and VCI translation. See also: ATM."
    },
    {
       "key":75,
       "value":"ATM user-user connection",
       "description":"A connection made by the ATM layer to supply communica- tion between at least two ATM service users, such as ATMM processes. These communica- tions can be uni- or bidirectional, using one or two VCs, respectively. See also: ATM layer and ATMM."
    },
    {
       "key":76,
       "value":"ATP",
       "description":"AppleTalk Transaction Protocol: A transport-level protocol that enables reliable transactions between two sockets; one requests the other to perform a given task and to report the results. ATP fastens the request and response together, assuring a loss-free exchange of request-response pairs."
    },
    {
       "key":77,
       "value":"attenuation",
       "description":"In communication, weakening or loss of signal energy, typically caused by distance."
    },
    {
       "key":78,
       "value":"AURP",
       "description":"AppleTalk Update-based Routing Protocol: A technique for encapsulating Apple- Talk traffic in the header of a foreign protocol that allows the connection of at least two noncontiguous AppleTalk internetworks through a foreign network (such as TCP/IP) to create an AppleTalk WAN. The connection made is called an AURP tunnel. By exchanging routing information between exterior routers, the AURP maintains routing tables for the complete AppleTalk WAN. See also: AURP tunnel."
    },
    {
       "key":79,
       "value":"AURP tunnel",
       "description":"A connection made in an AURP WAN that acts as a single, virtual link between AppleTalk internetworks separated physically by a foreign network such as a TCP/ IP network. See also: AURP."
    },
    {
       "key":80,
       "value":"authentication",
       "description":"The first component in the AAA model. Users are typically authenticated via a username and password, which are used to uniquely identify them."
    },
    {
       "key":81,
       "value":"authority",
       "description":"zone A portion of the domain-name tree associated with DNS for which one name server is the authority. See also: DNS."
    },
    {
       "key":82,
       "value":"authorization",
       "description":"The act of permitting access to a resource based on authentication informa- tion in the AAA model."
    },
    {
       "key":83,
       "value":"autoconfiguration",
       "description":"This is an especially useful solution because it allows devices on a network to address themselves with an IPv6 link-local unicast address as well as with a global unicast address."
    },
    {
       "key":84,
       "value":"autodetect mechanism",
       "description":"Used in Ethernet switch, hub, and interface cards to determine the duplex and speed that can be used."
    },
    {
       "key":85,
       "value":"auto duplex",
       "description":"A setting on layer 1 and layer 2 devices that sets the duplex of a switch or hub port automatically."
    },
    {
       "key":86,
       "value":"automatic call reconnect",
       "description":"A function that enables automatic call rerouting away from a failed trunk line."
    },
    {
       "key":87,
       "value":"autonomous confederation",
       "description":"A collection of self-governed systems that depend more on their own network accessibility and routing information than on information received from other systems or groups."
    },
    {
       "key":88,
       "value":"autonomous switching",
       "description":"The ability of Cisco routers to process packets more quickly by using the ciscoBus to switch packets independently of the system processor."
    },
    {
       "key":89,
       "value":"autonomous system",
       "description":"See: AS."
    },
    {
       "key":90,
       "value":"autonomous system boundary router (ASBR)",
       "description":"OSPF router that connects multiple ASs together."
    },
    {
       "key":91,
       "value":"autoreconfiguration",
       "description":"A procedure executed by nodes within the failure domain of a token ring wherein nodes automatically perform diagnostics, trying to reconfigure the network around failed areas."
    },
    {
       "key":92,
       "value":"auxiliary port",
       "description":"The console port on the back of Cisco routers that allows you to connect a modem and dial the router and make console configuration settings."
    },
    {
       "key":93,
       "value":"B8ZS",
       "description":"Binary 8-zero substitution: A line-code type, interpreted at the remote end of the connection, that uses a special code substitution whenever eight consecutive zeros are trans- mitted over the link on T1 and E1 circuits. This technique assures ones-density independent of the data stream. Also known as bipolar 8-zero substitution. Contrast with: AMI. See also: ones density."
    },
    {
       "key":94,
       "value":"backbone",
       "description":"The basic portion of the network that provides the primary path for traffic sent to and initiated from other networks."
    },
    {
       "key":95,
       "value":"back end",
       "description":"A node or software program supplying services to a front end. See also: server."
    },
    {
       "key":96,
       "value":"bandwidth",
       "description":"The gap between the highest and lowest frequencies employed by network signals. More commonly, it refers to the rated throughput capacity of a network protocol or medium."
    },
    {
       "key":97,
       "value":"bandwidth on demand (BoD)",
       "description":"This function allows an additional B channel to be used to increase the amount of bandwidth available for a particular connection."
    },
    {
       "key":98,
       "value":"banner",
       "description":"Used in the configuration of Cisco routers for administrative messages."
    },
    {
       "key":99,
       "value":"baseband",
       "description":"A feature of a network technology that uses only one carrier frequency. Ethernet is an example. Also named narrowband. Compare with: broadband."
    },
    {
       "key":100,
       "value":"baseline",
       "description":"Historical data about the network and routine utilization information. This information can be used to determine whether there were recent changes made to the net- work that may contribute to the problem at hand."
    },
    {
       "key":101,
       "value":"Basic Management Setup",
       "description":"Used with Cisco routers when in setup mode. Provides only enough management and configuration to get the router working so someone can telnet into the router and configure it."
    },
    {
       "key":102,
       "value":"baud",
       "description":"Synonymous with bits per second (bps), if each signal element represents 1 bit. It is a unit of signaling speed equivalent to the number of separate signal elements transmitted per second."
    },
    {
       "key":103,
       "value":"B channel",
       "description":"Bearer channel: A full-duplex, 64 Kbps channel in ISDN that transmits user data. Compare with: D channel, E channel, and H channel."
    },
    {
       "key":104,
       "value":"BDR",
       "description":"Backup designated router: This is used in an OSPF network to back up the designated router in case of failure."
    },
    {
       "key":105,
       "value":"beacon",
       "description":"An FDDI frame or Token Ring frame that points to a serious problem with the ring, such as a broken cable. The beacon frame carries the address of the station thought to be down. See also: failure domain."
    },
    {
       "key":106,
       "value":"BECN",
       "description":"Backward Explicit Congestion Notification: BECN is the bit set by a Frame Relay network in frames moving away from frames headed into a congested path. A DTE that receives frames with the BECN may ask higher-level protocols to take necessary flow control measures. Compare with: FECN."
    },
    {
       "key":107,
       "value":"BGP4",
       "description":"BGP version 4: Version 4 of the interdomain routing protocol most commonly used on the Internet. BGP4 supports CIDR and uses route-counting mechanisms to decrease the size of routing tables. See also: CIDR."
    },
    {
       "key":108,
       "value":"BGP Identifier",
       "description":"The BGP Identifier field contains a value that identifies the BGP speaker. This is a random value chosen by the BGP router when sending an OPEN message."
    },
    {
       "key":109,
       "value":"BGP neighbors",
       "description":"Two routers running BGP that begin a communication process to exchange dynamic routing information; they use a TCP port at layer 4 of the OSI reference model. Specifically, TCP port 179 is used. Also known as BGP peers."
    },
    {
       "key":110,
       "value":"BGP peers",
       "description":"See: BGP neighbors."
    },
    {
       "key":111,
       "value":"BGP speaker",
       "description":"A router that advertises its prefixes or routes."
    },
    {
       "key":112,
       "value":"bidirectional shared tree",
       "description":"A method of shared tree multicast forwarding. This method allows group members to receive data from the source or the RP, whichever is closer."
    },
    {
       "key":113,
       "value":"binary digit",
       "description":"A two-character numbering method that uses ones and zeros. The binary numbering system underlies all digital representation of information."
    },
    {
       "key":114,
       "value":"binding",
       "description":"Configuring a Network layer protocol to use a certain frame type on a LAN."
    },
    {
       "key":115,
       "value":"BIP",
       "description":"Bit Interleaved Parity: A method used in ATM to monitor errors on a link, by send- ing a check bit or word in the link overhead for the previous block or frame. This allows bit errors in transmissions to be found and delivered as maintenance information."
    },
    {
       "key":116,
       "value":"BISDN",
       "description":"Broadband ISDN: ITU-T standards created to manage high-bandwidth technolo- gies such as video. BISDN presently employs ATM technology along SONET-based trans- mission circuits, supplying data rates typically between 155 Mbps and 622 Mbps and now even into the gigabyte range (if you have the big bucks). See also: BRI, ISDN, and PRI."
    },
    {
       "key":117,
       "value":"bit",
       "description":"One binary digit; either a 1 or a 0. Eight bits make a byte."
    },
    {
       "key":118,
       "value":"bit-oriented protocol",
       "description":"Regardless of frame content, the class of Data Link layer com- munication protocols that transmits frames. Bit-oriented protocols, as compared with byte-oriented, supply more efficient and trustworthy full-duplex operation. Compare with: byte-oriented protocol."
    },
    {
       "key":119,
       "value":"block size",
       "description":"Number of hosts that can be used in a subnet. Block sizes typically can be used in increments of 4, 8, 16, 32, 64, and 128."
    },
    {
       "key":120,
       "value":"Boot ROM",
       "description":"Used in routers to put the router into bootstrap mode. Bootstrap mode then boots the device with an operating system. The ROM can also hold a small Cisco IOS."
    },
    {
       "key":121,
       "value":"boot sequence",
       "description":"Defines how a router boots. The configuration register tells the router where to boot the IOS from as well as how to load the configuration."
    },
    {
       "key":122,
       "value":"bootstrap protocol",
       "description":"A protocol used to dynamically assign IP addresses and gateways to requesting clients."
    },
    {
       "key":123,
       "value":"border gateway",
       "description":"A router that facilitates communication with routers in different autono- mous systems."
    },
    {
       "key":124,
       "value":"border peer",
       "description":"The device in charge of a peer group; it exists at the edge of a hierarchical design. When any member of the peer group wants to locate a resource, it sends a single explorer to the border peer. The border peer then forwards this request on behalf of the requesting router, thus eliminating duplicate traffic."
    },
    {
       "key":125,
       "value":"border router",
       "description":"Typically defined within Open Shortest Path First (OSPF) as a router that connects an area to the backbone area. However, a border router can be a router that con- nects a company to the Internet as well. See also: OSPF."
    },
    {
       "key":126,
       "value":"BPDU",
       "description":"Bridge Protocol Data Unit: A Spanning Tree Protocol initializing packet that is sent at definable intervals for the purpose of exchanging information among bridges in networks."
    },
    {
       "key":127,
       "value":"BRI",
       "description":"Basic Rate Interface: The ISDN interface that facilitates circuit-switched communica- tion between video, data, and voice; it is made up of two B channels (64 Kbps each) and one D channel (16 Kbps). Compare with: PRI. See also: BISDN."
    },
    {
       "key":128,
       "value":"bridge",
       "description":"A device for connecting two segments of a network and transmitting packets between them. Both segments must use identical protocols to communicate. Bridges function at the Data Link layer, layer 2 of the OSI reference model. The purpose of a bridge is to filter, send, or flood any incoming frame, based on the MAC address of that particular frame."
    },
    {
       "key":129,
       "value":"bridge group",
       "description":"Used in the router configuration of bridging, bridge groups are defined by a unique number. Network traffic is bridged between all interfaces that are members of the same bridge group."
    },
    {
       "key":130,
       "value":"bridge identifier",
       "description":"Used to elect the root bridge in a layer 2 switched internetwork. The bridge ID is a combination of the bridge priority and base MAC address."
    },
    {
       "key":131,
       "value":"bridge priority",
       "description":"Sets the STP priority of the bridge. All bridge priorities are set to 32768 by default."
    },
    {
       "key":132,
       "value":"bridging loop",
       "description":"Loops occur in a bridged network if more than one link to a network exists and the STP protocol is not turned on."
    },
    {
       "key":133,
       "value":"broadband",
       "description":"A transmission methodology for multiplexing several independent signals onto one cable. In telecommunications, broadband is classified as any channel with band- width greater than 4 kHz (typical voice grade). In LAN terminology, it is classified as a coaxial cable on which analog signaling is employed. Also known as wideband."
    },
    {
       "key":134,
       "value":"broadcast address",
       "description":"Used in both logical addressing and hardware addressing. In logical addressing, the host addresses will be all ones. With hardware addressing, the hardware address will be all ones in binary (all Fs in hex)."
    },
    {
       "key":135,
       "value":"broadcast domain",
       "description":"A group of devices receiving broadcast frames initiating from any device within the group. Because routers do not forward broadcast frames, broadcast domains are not forwarded from one broadcast to another."
    },
    {
       "key":136,
       "value":"broadcast (multi-access) networks",
       "description":"Broadcast (multi-access) networks such as Ethernet allow multiple devices to connect to (or access) the same network, and they provide a broad- cast ability in which a single packet is delivered to all nodes on the network. A data frame or packet that is transmitted to every node on the local network segment (as defined by the broadcast domain). Broadcasts are known by their broadcast address, which is a destination network and host address with all the bits turned on."
    },
    {
       "key":137,
       "value":"broadcast storm",
       "description":"An undesired event on the network caused by the simultaneous trans- mission of any number of broadcasts across the network segment. Such an occurrence can overwhelm network bandwidth, resulting in time-outs."
    },
    {
       "key":138,
       "value":"buffer",
       "description":"A storage area dedicated to handling data while in transit. Buffers are used to receive/store sporadic deliveries of data bursts (usually received from faster devices), compensating for the variations in processing speed. Incoming information is stored until everything is received prior to sending data on. Also known as an information buffer."
    },
    {
       "key":139,
       "value":"bursting",
       "description":"Some technologies, including ATM and Frame Relay, are considered burstable. This means that user data can exceed the bandwidth normally reserved for the connec- tion; however, it cannot exceed the port speed. An example of this would be a 128 Kbps Frame Relay CIR on a T1—depending on the vendor, it may be possible to send more than 128 Kbps for a short time."
    },
    {
       "key":140,
       "value":"bus",
       "description":"Any common physical path, typically wires or copper, through which a digital signal can be used to send data from one part of a computer to another."
    },
    {
       "key":141,
       "value":"BUS",
       "description":"Broadcast and unknown servers: In LAN emulation, the hardware or software responsible for resolving all broadcasts and packets with unknown (unregistered) addresses into the point-to-point virtual circuits required by ATM. See also: LANE, LEC, LECS, and LES."
    },
    {
       "key":142,
       "value":"bus topology",
       "description":"A linear LAN architecture in which transmissions from various stations on the network are reproduced over the length of the medium and are accepted by all other stations. Compare with: ring topology and star topology."
    },
    {
       "key":143,
       "value":"BX.25",
       "description":"AT&T\u0027s use of X.25. See also: X.25."
    },
    {
       "key":144,
       "value":"bypass",
       "description":"mode An FDDI and Token Ring network operation that deletes an interface."
    },
    {
       "key":145,
       "value":"bypass relay",
       "description":"A device that enables a particular interface in the token ring to be closed down and affectively taken off the ring."
    },
    {
       "key":146,
       "value":"byte",
       "description":"Eight bits. See also: octet."
    },
    {
       "key":147,
       "value":"byte-oriented protocol",
       "description":"Any type of data-link communication protocol that, in order to mark the boundaries of frames, uses a specific character from the user character set. These protocols have generally been superseded by bit-oriented protocols. Compare with: bit- oriented protocol."
    },
    {
       "key":148,
       "value":"cable range",
       "description":"In an extended AppleTalk network, the range of numbers allotted for use by existing nodes on the network. The value of the cable range can be anywhere from a single network number to a sequence of several touching network numbers. Node addresses are determined by their cable range value."
    },
    {
       "key":149,
       "value":"CAC",
       "description":"Connection Admission Control: The sequence of actions executed by every ATM switch while connection setup is performed in order to determine if a request for connection is violating the guarantees of QoS for established connections. Also, CAC is used to route a connection request through an ATM network."
    },
    {
       "key":150,
       "value":"call admission control",
       "description":"A device for managing traffic in ATM networks. It determines the possibility of a path containing adequate bandwidth for a requested VCC."
    },
    {
       "key":151,
       "value":"call establishment",
       "description":"Used to reference an ISDN call setup scheme when the call is working."
    },
    {
       "key":152,
       "value":"call priority",
       "description":"In circuit-switched systems, the defining priority given to each originating port; it specifies the order in which calls will be reconnected. Additionally, call priority identifies which calls are allowed during a bandwidth reservation."
    },
    {
       "key":153,
       "value":"call setup",
       "description":"Handshaking scheme that defines how a source and destination device will establish a call to each other."
    },
    {
       "key":154,
       "value":"call setup time",
       "description":"The length of time necessary to affect a switched call between DTE devices."
    },
    {
       "key":155,
       "value":"CBR",
       "description":"Constant bit rate: An ATM Forum QoS class created for use in ATM networks. CBR is used for connections that rely on precision clocking to guarantee trustworthy delivery. Compare with: ABR and VBR."
    },
    {
       "key":156,
       "value":"CD",
       "description":"Carrier detect: A signal indicating that an interface is active or that a connection generated by a modem has been established."
    },
    {
       "key":157,
       "value":"CDP",
       "description":"Cisco Discovery Protocol: Cisco\u0027s proprietary protocol that is used to tell a neighbor Cisco device about the type of hardware, software version, and active interfaces the Cisco device is using. It uses a SNAP frame between devices and is not routable."
    },
    {
       "key":158,
       "value":"CDP holdtime",
       "description":"The amount of time a router will hold Cisco Discovery Protocol informa- tion received from a neighbor router before discarding it if the information is not updated by the neighbor. This timer is set to 180 seconds by default."
    },
    {
       "key":159,
       "value":"CDP timer",
       "description":"The amount of time between Cisco Discovery Protocol advertisements trans- mitted out of all router interfaces. The CDP timer is 90 seconds by default."
    },
    {
       "key":160,
       "value":"CDVT",
       "description":"Cell Delay Variation Tolerance: A QoS parameter for traffic management in ATM networks specified when a connection is established. The allowable fluctuation levels for data samples taken by the PCR in CBR transmissions are determined by the CDVT. See also: CBR and PCR."
    },
    {
       "key":161,
       "value":"cell",
       "description":"In ATM networking, the basic unit of data for switching and multiplexing. Cells have a defined length of 53 bytes, including a 5-byte header that identifies the cell\u0027s data stream and 48 bytes of payload. See also: cell relay."
    },
    {
       "key":162,
       "value":"cell payload scrambling",
       "description":"The method by which an ATM switch maintains framing on some medium-speed edge and trunk interfaces (T3 or E3 circuits). Cell payload scrambling rearranges the data portion of a cell to maintain the line synchronization with certain com- mon bit patterns."
    },
    {
       "key":163,
       "value":"cell relay",
       "description":"A technology that uses small packets of fixed size, known as cells. Their fixed length enables cells to be processed and switched in hardware at high speeds, making this technology the foundation for ATM and other high-speed network protocols. See also: cell."
    },
    {
       "key":164,
       "value":"Centrex",
       "description":"A local exchange carrier service providing local switching that resembles an on- site PBX. Centrex has no on-site switching capability. Therefore, all customer connections return to the central office (CO). See also: CO."
    },
    {
       "key":165,
       "value":"CER",
       "description":"Cell error ratio: In ATM, the ratio of transmitted cells having errors to the total num- ber of cells transmitted within a certain span of time."
    },
    {
       "key":166,
       "value":"CGMP",
       "description":"Cisco Group Management Protocol: A proprietary protocol developed by Cisco. The router uses CGMP to send multicast membership commands to Catalyst switches."
    },
    {
       "key":167,
       "value":"channelized E1",
       "description":"Operating at 2.048 Mbps, an access link that is sectioned into 29 B channels and 1 D channel, supporting DDR, Frame Relay, and X.25. Compare with: channelized T1."
    },
    {
       "key":168,
       "value":"channelized T1",
       "description":"Operating at 1.544 Mbps, an access link that is sectioned into 23 B chan- nels and 1 D channel of 64 Kbps each, where individual channels or groups of channels connect to various destinations, supporting DDR, Frame Relay, and X.25. Compare with: channelized E1."
    },
    {
       "key":169,
       "value":"CHAP",
       "description":"Challenge Handshake Authentication Protocol: Supported on lines using PPP encapsulation, it is a security feature that identifies the remote end, helping to keep out unauthorized users. After CHAP is performed, the router or access server determines whether a given user is permitted access. It is a newer, more secure protocol than PAP. Compare with: PAP."
    },
    {
       "key":170,
       "value":"checksum",
       "description":"A test for ensuring the integrity of sent data. It is a number calculated from a series of values taken through a sequence of mathematical functions, typically placed at the end of the data from which it is calculated, and then recalculated at the receiving end for verification. Compare with: CRC."
    },
    {
       "key":171,
       "value":"choke packet",
       "description":"When congestion exists, it is a packet sent to inform a transmitter that it should decrease its sending rate."
    },
    {
       "key":172,
       "value":"CIDR",
       "description":"Classless Inter-Domain Routing: It allows a group of IP networks to appear to other networks as a unified, larger entity. In CIDR, IP addresses and their subnet masks are written as four dotted octets, followed by a forward slash and the number of masking bits (a form of subnet notation shorthand). See also: BGP4."
    },
    {
       "key":173,
       "value":"CIP",
       "description":"Channel Interface Processor: A channel attachment interface for use in Cisco 7000 series routers that connects a host mainframe to a control unit. This device eliminates the need for an FBP to attach channels."
    },
    {
       "key":174,
       "value":"CIR",
       "description":"Committed information rate: Averaged over a minimum span of time and measured in bits per second (bps), a Frame Relay network\u0027s agreed-upon minimum rate of transferring information."
    },
    {
       "key":175,
       "value":"circuit switching",
       "description":"Used with dial-up networks such as PPP and ISDN. Passes data, but needs to set up the connection first—just like making a phone call."
    },
    {
       "key":176,
       "value":"Cisco FRAD",
       "description":"Cisco Frame Relay Access Device: A Cisco product that supports Cisco IPS Frame Relay SNA services, connecting SDLC devices to Frame Relay without requiring an existing LAN. May be upgraded to a fully functioning multiprotocol router. Can activate conversion from SDLC to Ethernet and Token Ring, but does not support attached LANs. See also: FRAD."
    },
    {
       "key":177,
       "value":"CiscoFusion",
       "description":"Cisco\u0027s name for the internetworking architecture under which its Cisco IOS operates. It is designed to \u0027fuse\u0027 together the capabilities of its disparate collection of acquired routers and switches."
    },
    {
       "key":178,
       "value":"Cisco IOS",
       "description":"Cisco Internet Operating System software. The kernel of the Cisco line of rout- ers and switches that supplies shared functionality, scalability, and security for all products under its CiscoFusion architecture. See also: CiscoFusion."
    },
    {
       "key":179,
       "value":"CiscoView",
       "description":"GUI-based management software for Cisco networking devices, enabling dynamic status, statistics, and comprehensive configuration information. Displays a physical view of the Cisco device chassis and provides device-monitoring functions and fundamental troubleshooting capabilities. May be integrated with a number of SNMP- based network management platforms."
    },
    {
       "key":180,
       "value":"Class A network",
       "description":"Part of the Internet Protocol hierarchical addressing scheme. Class A networks have only 8 bits for defining networks and 24 bits for defining hosts and subnets on each network."
    },
    {
       "key":181,
       "value":"Class B network",
       "description":"Part of the Internet Protocol hierarchical addressing scheme. Class B networks have 16 bits for defining networks and 16 bits for defining hosts and subnets on each network."
    },
    {
       "key":182,
       "value":"Class C network",
       "description":"Part of the Internet Protocol hierarchical addressing scheme. Class C networks have 24 bits for defining networks and only 8 bits for defining hosts and subnets on each network."
    },
    {
       "key":183,
       "value":"classful routing",
       "description":"Routing protocols that do not send subnet mask information when a route update is sent out."
    },
    {
       "key":184,
       "value":"classical IP over ATM",
       "description":"Defined in RFC 1577, the specification for running IP over ATM that maximizes ATM features. Also known as CIA."
    },
    {
       "key":185,
       "value":"classless routing",
       "description":"Routing that sends subnet mask information in the routing updates. Classless routing allows variable length subnet masking and supernetting. Routing proto- cols that support classless routing are RIP version 2, EIGRP, and OSPF."
    },
    {
       "key":186,
       "value":"CLI",
       "description":"Command-line interface: Allows you to configure Cisco routers and switches with maximum flexibility."
    },
    {
       "key":187,
       "value":"CLP",
       "description":"Cell loss priority: The area in the ATM cell header that determines the likelihood of a cell being dropped during network congestion. Cells with CLP = 0 are considered insured traffic and are not apt to be dropped. Cells with CLP = 1 are considered best-effort traffic that may be dropped during congested episodes, delivering more resources to handle insured traffic."
    },
    {
       "key":188,
       "value":"CLR",
       "description":"Cell loss ratio: The ratio of discarded cells to successfully delivered cells in ATM. CLR can be designated a QoS parameter when a connection is being established."
    },
    {
       "key":189,
       "value":"CO",
       "description":"Central office: The local telephone company office where all loops in a certain area connect and where circuit switching of subscriber lines occurs."
    },
    {
       "key":190,
       "value":"collapsed backbone",
       "description":"A nondistributed backbone where all network segments are con- nected to each other through an internetworking device. A collapsed backbone can be a virtual network segment at work in a device such as a router, hub, or switch."
    },
    {
       "key":191,
       "value":"collision",
       "description":"The effect of two nodes sending transmissions simultaneously in Ethernet. When they meet on the physical media, the frames from each node collide and are damaged. See also: collision domain."
    },
    {
       "key":192,
       "value":"collision domain",
       "description":"The network area in Ethernet over which frames that have collided will be detected. Collisions are propagated by hubs and repeaters, but not by LAN switches, routers, or bridges. See also: collision."
    },
    {
       "key":193,
       "value":"composite metric",
       "description":"Used with routing protocols, such as IGRP and EIGRP, that use more than one metric to find the best path to a remote network. IGRP and EIGRP both use band- width and delay of the line by default. However, maximum transmission unit (MTU), load, and reliability of a link can be used as well."
    },
    {
       "key":194,
       "value":"compression",
       "description":"A technique to send more data across a link than would be normally per- mitted by representing repetitious strings of data with a single marker."
    },
    {
       "key":195,
       "value":"configuration register",
       "description":"A 16-bit configurable value stored in hardware or software that determines how Cisco routers function during initialization. In hardware, the bit position is set using a jumper. In software, it is set by specifying specific bit patterns used to set startup options, configured using a hexadecimal value with configuration commands."
    },
    {
       "key":196,
       "value":"congestion",
       "description":"Traffic that exceeds the network\u0027s ability to handle it."
    },
    {
       "key":197,
       "value":"congestion avoidance",
       "description":"To minimize delays, the method a network uses to control traffic entering the system. Lower-priority traffic is discarded at the edge of the network when indicators signal it cannot be delivered, thus resources are used efficiently."
    },
    {
       "key":198,
       "value":"congestion collapse",
       "description":"The situation that results from the retransmission of packets in ATM networks where little or no traffic successfully arrives at destination points. It usually happens in networks made of switches with ineffective or inadequate buffering capabilities combined with poor packet discard or ABR congestion feedback mechanisms."
    },
    {
       "key":199,
       "value":"connection ID",
       "description":"Identifications given to each Telnet session into a router. The show sessions command will give you the connections a local router will have to a remote router. The show users command will show the connection IDs of users telnetted into your local router."
    },
    {
       "key":200,
       "value":"connectionless",
       "description":"Data transfer that occurs without the creation of a virtual circuit. It has low overhead, uses best-effort delivery, and is not reliable. Contrast with: connection-oriented. See also: virtual circuit (VC)."
    },
    {
       "key":201,
       "value":"Connectionless Network Service (CLNS)",
       "description":"See: connectionless."
    },
    {
       "key":202,
       "value":"connection-oriented",
       "description":"Data transfer method that sets up a virtual circuit before any data is transferred. Uses acknowledgments and flow control for reliable data transfer. Contrast with: connectionless. See also: virtual circuit (VC)."
    },
    {
       "key":203,
       "value":"console port",
       "description":"Typically an RJ45 (8-pin modular) port on a Cisco router and switch that allows command-line interface capability."
    },
    {
       "key":204,
       "value":"control direct VCC",
       "description":"One of two control connections defined by Phase I LAN emulation; a bidirectional virtual control connection (VCC) established in ATM by an LEC to an LES. See also: control distribute VCC."
    },
    {
       "key":205,
       "value":"control distribute VCC",
       "description":"One of two control connections defined by Phase 1 LAN emula- tion; a unidirectional virtual control connection (VCC) set up in ATM from an LES to an LEC. Usually, the VCC is a point-to-multipoint connection. See also: control direct VCC."
    },
    {
       "key":206,
       "value":"convergence",
       "description":"The process required for all routers in an internetwork to update their rout- ing tables and create a consistent view of the network using the best possible paths. No user data is passed during an STP convergence time."
    },
    {
       "key":207,
       "value":"core layer",
       "description":"Top layer in the Cisco three-layer hierarchical model, which helps you design, build, and maintain Cisco hierarchical networks. The core layer passes packets quickly to distribution layer devices only. No packet filtering should take place at this layer."
    },
    {
       "key":208,
       "value":"cost",
       "description":"Also known as path cost, an arbitrary value, based on hop count, bandwidth, or another calculation, that is typically assigned by a network administrator and used by the routing protocol to compare different routes through an internetwork. Routing protocols use cost values to select the best path to a certain destination: the lowest cost identifies the best path. See also: routing metric."
    },
    {
       "key":209,
       "value":"count to infinity",
       "description":"In routing algorithms, a problem occurring when routers keep increasing the hop count to a particular network because the routing algorithms are slow to converge. To avoid this problem, various solutions have been implemented into each of the different routing protocols. Some of those solutions include defining a maximum hop count (defining infinity), route positioning, positioning reverse and split horizon."
    },
    {
       "key":210,
       "value":"CPCS",
       "description":"Common Part Convergence Sublayer: One of two AAL sublayers that is service dependent, it is further segmented into the CS and SAR sublayers. The CPCS prepares data for transmission across the ATM network; it creates the 48-byte payload cells that are sent to the ATM layer. See also: AAL and ATM layer."
    },
    {
       "key":211,
       "value":"CPE",
       "description":"Customer premises equipment: Items such as telephones, modems, and terminals installed at customer locations and connected to the service provider network."
    },
    {
       "key":212,
       "value":"crankback",
       "description":"In ATM, a correction technique used when a node somewhere on a chosen path cannot accept a connection setup request, blocking the request. The path is rolled back to an intermediate node, which then uses GCAC to attempt to find an alternate path to the final destination."
    },
    {
       "key":213,
       "value":"CRC",
       "description":"Cyclic redundancy check: A methodology that detects errors, whereby the frame recipi- ent makes a calculation by dividing frame contents with a prime binary divisor and compares the remainder to a value stored in the frame by the sending node. Contrast with: checksum."
    },
    {
       "key":214,
       "value":"crossover cable",
       "description":"Type of Ethernet cable that connects a switch to a switch, a host to a host, a hub to a hub, or a switch to a hub."
    },
    {
       "key":215,
       "value":"CSMA/CD",
       "description":"Carrier Sense Multiple Access with Collision Detection: A technology defined by the Ethernet IEEE 802.3 committee. Each device senses the cable for a digital signal before transmitting. Also, CSMA/CD allows all devices on the network to share the same cable, but one at a time. If two devices transmit at the same time, a frame collision will occur and a jamming pattern will be sent; the devices will stop transmitting, wait a prede- termined amount of time as well as a self-imposed random amount of time, and then try to transmit again."
    },
    {
       "key":216,
       "value":"CSU/DSU",
       "description":"Channel service unit/data service unit: Physical layer device used in wide area networks to convert the CPE digital signals to what is understood by the provider\u0027s switch. A CSU/DSU is typically one device that plugs into an RJ45 (8-pin modular) jack, known as the demarcation point."
    },
    {
       "key":217,
       "value":"CTD",
       "description":"Cell transfer delay: For a given connection in ATM, the time period between a cell exit event at the source user-network interface (UNI) and the corresponding cell entry event at the destination. The CTD between these points is the sum of the total inter-ATM trans- mission delay and the total ATM processing delay."
    },
    {
       "key":218,
       "value":"cumulative interface delay",
       "description":"This is a Cisco term for delay of the line. The composite metric in IGRP and EIGRP is calculated by using the bandwidth and delay of the line by default."
    },
    {
       "key":219,
       "value":"cut-through frame switching",
       "description":"A frame-switching technique that flows data through a switch so that the leading edge exits the switch at the output port before the packet finishes entering the input port. Frames will be read, processed, and forwarded by devices that use cut-through switching as soon as the destination address of the frame is confirmed and the outgoing port is identified."
    },
    {
       "key":220,
       "value":"data compression",
       "description":"See: compression."
    },
    {
       "key":221,
       "value":"data direct VCC",
       "description":"A bidirectional point-to-point virtual control connection (VCC) set up between two LECs in ATM and one of three data connections defined by Phase 1 LAN emu- lation. Because data direct VCCs do not guarantee QoS, they are generally reserved for UBR and ABR connections. Compare with: control distribute VCC and control direct VCC."
    },
    {
       "key":222,
       "value":"data frame",
       "description":"Protocol data unit encapsulation at the Data Link layer of the OSI reference model. Encapsulates packets from the Network layer and prepares the data for transmission on a network medium."
    },
    {
       "key":223,
       "value":"datagram",
       "description":"A logical collection of information transmitted as a Network layer unit over a medium without a previously established virtual circuit. IP datagrams have become the primary information unit of the Internet. At various layers of the OSI reference model, the terms cell, frame, message, packet, and segment are also used for these logical information groupings."
    },
    {
       "key":224,
       "value":"Data Link Control layer",
       "description":"Layer 2 of the SNA architectural model, it is responsible for the transmission of data over a given physical link and compares somewhat to the Data Link layer of the OSI model."
    },
    {
       "key":225,
       "value":"Data Link layer",
       "description":"Layer 2 of the OSI reference model, it ensures the trustworthy transmis- sion of data across a physical link and is primarily concerned with physical addressing, line discipline, network topology, error notification, ordered delivery of frames, and flow control. The IEEE has further segmented this layer into the MAC sublayer and the LLC sublayer. Also known as the link layer. Can be compared somewhat to the data link control layer of the SNA model. See also: Application layer, LLC, MAC, Network layer, Physical layer, Presentation layer, Session layer, and Transport layer."
    },
    {
       "key":226,
       "value":"data terminal equipment",
       "description":"See: DTE."
    },
    {
       "key":227,
       "value":"DCC",
       "description":"Data Country Code: Developed by the ATM Forum, one of two ATM address for- mats designed for use by private networks. Compare with: ICD."
    },
    {
       "key":228,
       "value":"DCE",
       "description":"Data communication equipment (as defined by the EIA) or data circuit-terminating equipment (as defined by the ITU-T): The mechanisms and links of a communications net- work that make up the network portion of the user-to-network interface, such as modems. The DCE supplies the physical connection to the network, forwards traffic, and provides a clocking signal to synchronize data transmission between DTE and DCE devices. Compare with: DTE."
    },
    {
       "key":229,
       "value":"D channel",
       "description":"(1) Data channel: A full-duplex, 16 Kbps (BRI) or 64 Kbps (PRI) ISDN chan- nel. Compare with: B channel, E channel, and H channel. (2) In SNA, anything that pro- vides a connection between the processor and main storage with any peripherals."
    },
    {
       "key":230,
       "value":"DDP",
       "description":"Datagram Delivery Protocol: Used in the AppleTalk suite of protocols as a connec- tionless protocol that is responsible for sending datagrams through an internetwork."
    },
    {
       "key":231,
       "value":"DDR",
       "description":"Dial-on-demand routing: A technique that allows a router to automatically initiate and end a circuit-switched session per the requirements of the sending station. By mimicking keepalives, the router fools the end station into treating the session as active. DDR permits routing over ISDN or telephone lines via a modem or external ISDN terminal adapter."
    },
    {
       "key":232,
       "value":"DE",
       "description":"Discard Eligibility: Used in Frame Relay networks to tell a switch that a frame can be preferentially discarded if the switch is too busy. The DE is a field in the frame that is turned on by transmitting routers if the committed information rate (CIR) is oversubscribed or set to 0."
    },
    {
       "key":233,
       "value":"dedicated line",
       "description":"Point-to-point connection that does not share any bandwidth."
    },
    {
       "key":234,
       "value":"de-encapsulation",
       "description":"The technique used by layered protocols in which a layer removes header information from the protocol data unit (PDU) from the layer below. See: encapsulation."
    },
    {
       "key":235,
       "value":"default route",
       "description":"The static routing table entry used to direct frames whose next hop is not otherwise spelled out in the routing table."
    },
    {
       "key":236,
       "value":"delay",
       "description":"The time elapsed between a sender\u0027s initiation of a transaction and the first response they receive. Also, the time needed to move a packet from its source to its destina- tion over a path. See also: latency."
    },
    {
       "key":237,
       "value":"demarc",
       "description":"The demarcation point between the customer premises equipment (CPE) and the telco\u0027s carrier equipment."
    },
    {
       "key":238,
       "value":"demodulation",
       "description":"A series of steps that return a modulated signal to its original form. When receiving, a modem demodulates an analog signal to its original digital form (and, con- versely, modulates the digital data it sends into an analog signal). See also: modulation."
    },
    {
       "key":239,
       "value":"demultiplexing",
       "description":"The process of converting a multiplexed signal comprising more than one input stream back into separate output streams. See also: multiplexing."
    },
    {
       "key":240,
       "value":"designated bridge",
       "description":"In the process of forwarding a frame from a segment to the root bridge, the bridge with the lowest root path cost."
    },
    {
       "key":241,
       "value":"designated port",
       "description":"Used with the Spanning Tree Protocol (STP) to designate forwarding ports. If there are multiple links to the same network, STP will shut a port down to stop network loops."
    },
    {
       "key":242,
       "value":"designated router (DR)",
       "description":"An OSPF router that creates LSAs for a multi-access network and is required to perform other special tasks in OSPF operations. Multi-access OSPF networks that maintain a minimum of two attached routers identify one router that is chosen by the OSPF Hello protocol, which makes possible a decrease in the number of adjacencies neces- sary on a multi-access network. This in turn reduces the quantity of routing protocol traffic and the physical size of the database."
    },
    {
       "key":243,
       "value":"desktop layer",
       "description":"The access layer (one of the layers in Cisco\u0027s three-layer hierarchical model) is sometimes referred to as the desktop layer. The access layer controls user and workgroup access to internetwork resources."
    },
    {
       "key":244,
       "value":"destination address",
       "description":"The address for the network device(s) that will receive a packet."
    },
    {
       "key":245,
       "value":"DHCP",
       "description":"Dynamic Host Configuration Protocol: DHCP is a superset of the BootP protocol. This means that it uses the same protocol structure as BootP, but it has enhancements added. Both of these protocols use servers that dynamically configure clients when requested. The two major enhancements are address pools and lease times."
    },
    {
       "key":246,
       "value":"dial backup",
       "description":"Dial backup connections are typically used to provide redundancy to Frame Relay connections. The backup link is activated over an analog modem or ISDN."
    },
    {
       "key":247,
       "value":"directed broadcast",
       "description":"A data frame or packet that is transmitted to a specific group of nodes on a remote network segment. Directed broadcasts are known by their broadcast address, which is a destination subnet address with all the host bits turned on."
    },
    {
       "key":248,
       "value":"discovery mode",
       "description":"Also known as dynamic configuration, this technique is used by an AppleTalk interface to gain information from a working node about an attached network. The information is subsequently used by the interface for self-configuration."
    },
    {
       "key":249,
       "value":"distance-vector protocols",
       "description":"The distance-vector protocols find the best path to a remote network by judging distance. Each time a packet goes through a router, that\u0027s called a hop. The route with the least number of hops to the network is determined to be the best route. However, Cisco\u0027s IGRP is considered distance vector and uses a composite metric of band- width and delay of the line to determine the best path to a remote network."
    },
    {
       "key":250,
       "value":"distance-vector routing algorithm",
       "description":"In order to find the shortest path, this group of rout- ing algorithms reports on the number of hops in a given route, requiring each router to send its complete routing table with each update, but only to its neighbors. Routing algorithms of this type tend to generate loops, but they are fundamentally simpler than their link-state counterparts. See also: link-state routing algorithm and SPF."
    },
    {
       "key":251,
       "value":"distribution layer",
       "description":"Middle layer of the Cisco three-layer hierarchical model, which helps you design, install, and maintain Cisco hierarchical networks. The distribution layer is the point where access layer devices connect. Routing is performed at this layer."
    },
    {
       "key":252,
       "value":"DLCI",
       "description":"Data Link Connection Identifier: Used to identify virtual circuits in a Frame Relay network."
    },
    {
       "key":253,
       "value":"DLSw",
       "description":"Data Link Switching: IBM developed Data Link Switching (DLSw) in 1992 to provide support for SNA (Systems Network Architecture) and NetBIOS protocols in router- based networks. SNA and NetBIOS are nonroutable protocols that do not contain any logi- cal layer 3 network information. DLSw encapsulates these protocols into TCP/IP messages that can be routed and is an alternative to remote source-route bridging (RSRB)."
    },
    {
       "key":254,
       "value":"DLSw+",
       "description":"Cisco\u0027s implementation of DLSw. In addition to support for the RFC standards, Cisco added enhancements intended to increase scalability and to improve performance and availability."
    },
    {
       "key":255,
       "value":"DNS",
       "description":"Domain Name System: Used to resolve hostnames to IP addresses."
    },
    {
       "key":256,
       "value":"DSAP",
       "description":"Destination service access point: The service access point of a network node, specified in the destination field of a packet. See also: SSAP and SAP."
    },
    {
       "key":257,
       "value":"DSR",
       "description":"Data set ready: When a DCE is powered up and ready to run, this EIA/TIA-232 interface circuit is also engaged."
    },
    {
       "key":258,
       "value":"DTE",
       "description":"Data terminal equipment: Any device located at the user end of a user-network inter- face serving as a destination, a source, or both. DTE includes devices such as multiplexers, routers, protocol translators, and computers. The connection to a data network is made through data communication equipment (DCE) such as a modem, using the clocking signals generated by that device. See also: DCE."
    },
    {
       "key":259,
       "value":"DTR",
       "description":"Data terminal ready: An activated EIA/TIA-232 circuit communicating to the DCE the state of preparedness of the DTE to transmit or receive data."
    },
    {
       "key":260,
       "value":"DUAL",
       "description":"Diffusing Update Algorithm: Used in Enhanced IGRP, this convergence algorithm provides loop-free operation throughout an entire route\u0027s computation. DUAL grants rout- ers involved in a topology revision the ability to synchronize simultaneously, while routers unaffected by this change are not involved. See also: Enhanced IGRP."
    },
    {
       "key":261,
       "value":"DVMRP",
       "description":"Distance Vector Multicast Routing Protocol: Based primarily on the Routing Information Protocol (RIP), this Internet gateway protocol implements a common, con- densed-mode IP multicast scheme, using IGMP to transfer routing datagrams between its neighbors. See also: IGMP."
    },
    {
       "key":262,
       "value":"DXI",
       "description":"Data Exchange Interface: DXI defines the effectiveness of a network device such as a router, bridge, or hub to act as an FEP to an ATM network by using a special DSU that accomplishes packet encapsulation."
    },
    {
       "key":263,
       "value":"dynamic entries",
       "description":"Used in layer 2 and layer 3 devices to dynamically create a table of either hardware addresses or logical addresses dynamically."
    },
    {
       "key":264,
       "value":"dynamic routing",
       "description":"Also known as adaptive routing, this technique automatically adapts to traffic or physical network revisions."
    },
    {
       "key":265,
       "value":"dynamic VLAN",
       "description":"An administrator will create an entry in a special server with the hard- ware addresses of all devices on the internetwork. The server will then report the associated VLAN to a switch that requests it based on the new device\u0027s hardware address."
    },
    {
       "key":266,
       "value":"E1",
       "description":"Generally used in Europe, a wide-area digital transmission scheme carrying data at 2.048 Mbps. E1 transmission lines are available for lease from common carriers for private use."
    },
    {
       "key":267,
       "value":"E.164",
       "description":"(1) Evolved from the standard telephone numbering system, the standard recom- mended by ITU-T for international telecommunication numbering, particularly in ISDN, SMDS, and BISDN. (2) Label of a field in an ATM address containing numbers in E.164 format."
    },
    {
       "key":268,
       "value":"eBGP",
       "description":"External Border Gateway Protocol: Used to exchange route information between different autonomous systems."
    },
    {
       "key":269,
       "value":"E channel",
       "description":"Echo channel: A 64 Kbps ISDN control channel used for circuit switching. Specific description of this channel can be found in the 1984 ITU-T ISDN specification, but it was dropped from the 1988 version. See also: B channel, D channel, and H channel."
    },
    {
       "key":270,
       "value":"edge device",
       "description":"A device that enables packets to be forwarded between legacy interfaces (such as Ethernet and Token Ring) and ATM interfaces based on information in the Data Link and Network layers. An edge device does not take part in the running of any Network layer routing protocol; it merely uses the route description protocol in order to get the for- warding information required."
    },
    {
       "key":271,
       "value":"EEPROM",
       "description":"Electronically erasable programmable read-only memory: Programmed after their manufacture, these nonvolatile memory chips can be erased if necessary using electric power and then reprogrammed. See also: EPROM and PROM."
    },
    {
       "key":272,
       "value":"EFCI",
       "description":"Explicit Forward Congestion Indication: A congestion feedback mode permitted by ABR service in an ATM network. The EFCI may be set by any network element that is in a state of immediate or certain congestion. The destination end system is able to carry out a protocol that adjusts and lowers the cell rate of the connection based on value of the EFCI. See also: ABR."
    },
    {
       "key":273,
       "value":"EIGRP",
       "description":"See: Enhanced IGRP."
    },
    {
       "key":274,
       "value":"EIP",
       "description":"Ethernet Interface Processor: A Cisco 7000 series router interface processor card, sup- plying 10 Mbps AUI ports to support Ethernet Version 1 and Ethernet Version 2 or IEEE 802.3 interfaces with a high-speed data path to other interface processors."
    },
    {
       "key":275,
       "value":"ELAN",
       "description":"Emulated LAN: An ATM network configured using a client-server model in order to emulate either an Ethernet or Token Ring LAN. Multiple ELANs can exist at the same time on a single ATM network and are made up of a LAN emulation client (LEC), a LAN emulation server (LES), a broadcast and unknown server (BUS), and a LAN emulation con- figuration server (LECS). ELANs are defined by the LANE specification. See also: LANE, LEC, LECS, and LES."
    },
    {
       "key":276,
       "value":"ELAP",
       "description":"EtherTalk Link Access Protocol: In an EtherTalk network, the link-access protocol constructed above the standard Ethernet Data Link layer."
    },
    {
       "key":277,
       "value":"encapsulation",
       "description":"The technique used by layered protocols in which a layer adds header information to the protocol data unit (PDU) from the layer above. For example, in Internet terminology, a packet would contain a header from the Data Link layer, followed by a header from the Network layer (IP), followed by a header from the Transport layer (TCP), followed by the application protocol data."
    },
    {
       "key":278,
       "value":"encryption",
       "description":"The conversion of information into a scrambled form that affectively disguises it to prevent unauthorized access. Every encryption scheme uses some well-defined algo- rithm, which is reversed at the receiving end by an opposite algorithm in a process known as decryption."
    },
    {
       "key":279,
       "value":"endpoints",
       "description":"See: BGP neighbors."
    },
    {
       "key":280,
       "value":"end-to-end VLANs",
       "description":"VLANs that span the switch fabric from end to end; all switches in end-to-end VLANs understand about all configured VLANs. End-to-end VLANs are con- figured to allow membership based on function, project, department, and so on."
    },
    {
       "key":281,
       "value":"Enhanced IGRP",
       "description":"Enhanced Interior Gateway Routing Protocol: An advanced routing protocol created by Cisco and combining the advantages of link-state and distance-vector protocols. Enhanced IGRP has superior convergence attributes, including high operating efficiency. See also: IGP, OSPF, and RIP."
    },
    {
       "key":282,
       "value":"enterprise network",
       "description":"A privately owned and operated network that joins most major loca- tions in a large company or organization."
    },
    {
       "key":283,
       "value":"EPROM",
       "description":"Erasable programmable read-only memory: Programmed after their manufac- ture, these nonvolatile memory chips can be erased if necessary using high-power light and then reprogrammed. See also: EEPROM and PROM."
    },
    {
       "key":284,
       "value":"ESF",
       "description":"Extended Superframe: Made up of 24 frames with 192 bits each, with the 193rd bit providing other functions, including timing. This is an enhanced version of SF. See also: SF."
    },
    {
       "key":285,
       "value":"Ethernet",
       "description":"A baseband LAN specification created by the Xerox Corporation and then improved through joint efforts of Xerox, Digital Equipment Corporation, and Intel. Ethernet is similar to the IEEE 802.3 series standard and, using CSMA/CD, operates over various types of cables at 10 Mbps. Also called DIX (Digital/Intel/Xerox) Ethernet. See also: 10Base-T, FastEthernet, and IEEE."
    },
    {
       "key":286,
       "value":"EtherTalk",
       "description":"A data-link product from Apple Computer that permits AppleTalk networks to be connected by Ethernet."
    },
    {
       "key":287,
       "value":"EUI-64",
       "description":"The Extended Unique Identifier format allows the device to use its MAC address and pad it to make the unique 64-bit interface ID used on an IPv6 interface."
    },
    {
       "key":288,
       "value":"excess burst size",
       "description":"The amount of traffic by which the user may exceed the committed burst size."
    },
    {
       "key":289,
       "value":"excess rate",
       "description":"In ATM networking, traffic exceeding a connection\u0027s insured rate. The excess rate is the maximum rate less the insured rate. Depending on the availability of network resources, excess traffic can be discarded during congestion episodes. Compare with: maximum rate."
    },
    {
       "key":290,
       "value":"EXEC session",
       "description":"Cisco term used to describe the command-line interface. The EXEC session exists in user mode and privileged mode."
    },
    {
       "key":291,
       "value":"expansion",
       "description":"The procedure of directing compressed data through an algorithm, restoring information to its original size."
    },
    {
       "key":292,
       "value":"expedited delivery",
       "description":"Specified by one protocol layer communicating either with other lay- ers or with the identical protocol layer in a different network device, an option that requires that identified data be processed faster."
    },
    {
       "key":293,
       "value":"explorer frame",
       "description":"Used with source-route bridging to find the route to the remote bridged network before a frame is transmitted."
    },
    {
       "key":294,
       "value":"explorer packet",
       "description":"An SNA packet transmitted by a source Token Ring device to find the path through a source-route-bridged network."
    },
    {
       "key":295,
       "value":"extended IP access list",
       "description":"IP access list that filters the network by logical address, protocol field in the Network layer header, and even the port field in the Transport layer header."
    },
    {
       "key":296,
       "value":"extended IPX access list",
       "description":"IPX access list that filters the network by logical IPX address, protocol field in the Network layer header, or even socket number in the Transport layer header."
    },
    {
       "key":297,
       "value":"extended setup",
       "description":"Used in setup mode to configure the router with more detail than basic setup mode. Allows multiple-protocol support and interface configuration."
    },
    {
       "key":298,
       "value":"external EIGRP",
       "description":"route Normally, the administrative distance of an EIGRP route is 90, but this is true only for what is known as an internal EIGRP route. These are routes origi- nated within a specific autonomous system by EIGRP routers that are members of the same autonomous system. The other type of route is called an external EIGRP route and has an administrative distance of 170, which is not so good. These routes appear within EIGRP route tables courtesy of either manual or automatic redistribution, and they represent net- works that originated outside of the EIGRP autonomous system."
    },
    {
       "key":299,
       "value":"failure domain",
       "description":"The region in which a failure has occurred in a token ring. When a station gains information that a serious problem, such as a cable break, has occurred with the net- work, it sends a beacon frame that includes the station reporting the failure, its NAUN, and everything between. This defines the failure domain. Beaconing then initiates the procedure known as autoreconfiguration. See also: autoreconfiguration and beacon."
    },
    {
       "key":300,
       "value":"fallback",
       "description":"In ATM networks, this mechanism is used for scouting a path if it isn\u0027t possible to locate one using customary methods. The device relaxes requirements for certain char- acteristics, such as delay, in an attempt to find a path that meets a certain set of the most important requirements."
    },
    {
       "key":301,
       "value":"FastEthernet",
       "description":"Any Ethernet specification with a speed of 100 Mbps. Fast Ethernet is 10 times faster than 10Base-T while retaining qualities such as MAC mechanisms, MTU, and frame format. These similarities make it possible for existing 10Base-T applications and management tools to be used on Fast Ethernet networks. Fast Ethernet is based on an extension of the IEEE 802.3 specification (IEEE 802.3u). Compare with: Ethernet. See also: 100Base-T, 100Base-TX, and IEEE."
    },
    {
       "key":302,
       "value":"fast switching",
       "description":"A Cisco feature that uses a route cache to speed packet-switching through a router. Contrast with: process switching."
    },
    {
       "key":303,
       "value":"fault tolerance",
       "description":"The extent to which a network device or a communication link can fail without communication being interrupted. Fault tolerance can be provided by added sec- ondary routes to a remote network."
    },
    {
       "key":304,
       "value":"FDDI",
       "description":"Fiber Distributed Data Interface: A LAN standard, defined by ANSI X3T9.5, that can run at speeds of up to 200 Mbps and uses token-passing media access on fiber-optic cable. For redundancy, FDDI can use a dual-ring architecture."
    },
    {
       "key":305,
       "value":"FDM",
       "description":"Frequency-division multiplexing: A technique that permits information from sev- eral channels to be assigned bandwidth on one wire based on frequency. See also: TDM, ATDM, and statistical multiplexing."
    },
    {
       "key":306,
       "value":"FECN",
       "description":"Forward Explicit Congestion Notification: A bit set by a Frame Relay network that informs the DTE receptor that congestion was encountered along the path from source to destination. A device receiving frames with the FECN bit set can ask higher-priority proto- cols to take flow-control action as needed. See also: BECN."
    },
    {
       "key":307,
       "value":"FEIP",
       "description":"Fast Ethernet Interface Processor: An interface processor employed on Cisco 7000 series routers, supporting up to two 100 Mbps 100Base-T ports."
    },
    {
       "key":308,
       "value":"filtering",
       "description":"Used to provide security on a network with access lists. LAN switches filter the network by MAC (hardware) address."
    },
    {
       "key":309,
       "value":"firewall",
       "description":"A barrier purposefully erected between any connected public networks and a private network—made up of a router or access server or several routers or access servers— that uses access lists and other methods to ensure the security of the private network."
    },
    {
       "key":310,
       "value":"fixed configuration router",
       "description":"A router that cannot be upgraded with any new interfaces."
    },
    {
       "key":311,
       "value":"flapping",
       "description":"Term used to describe a serial interface that is going up and down."
    },
    {
       "key":312,
       "value":"flash memory",
       "description":"Developed by Intel and licensed to other semiconductor manufacturers, it is nonvolatile storage that can be erased electronically and reprogrammed, physically located on an EEPROM chip. Flash memory permits software images to be stored, booted, and rewritten as needed. Cisco routers and switches use flash memory to hold the IOS by default. See also: EPROM and EEPROM."
    },
    {
       "key":313,
       "value":"flat network",
       "description":"Network that is one large collision domain and one large broadcast domain."
    },
    {
       "key":314,
       "value":"floating routes",
       "description":"Used with dynamic routing to provide backup routes (static routes) in case of failure."
    },
    {
       "key":315,
       "value":"floodin",
       "description":"g When traffic is received on an interface, it is then transmitted to every interface connected to that device (for example, a layer 2 switch) except the interface from which the traffic originated. This technique can be used for traffic transfer by bridges and switches throughout the network."
    },
    {
       "key":316,
       "value":"flow control",
       "description":"A methodology used to ensure that receiving units are not overwhelmed with data from sending devices. Pacing, as it is called in IBM networks, means that when buffers at a receiving unit are full, a message is transmitted to the sending unit to temporarily halt transmissions until all the data in the receiving buffer has been processed and the buffer is again ready for action."
    },
    {
       "key":317,
       "value":"forward/filter decisions",
       "description":"When a frame is received on an interface, the switch looks at the destination hardware address and finds the exit interface in the MAC database. The frame is forwarded out only the specified destination port."
    },
    {
       "key":318,
       "value":"FQDN",
       "description":"Fully qualified domain name: Used within the DNS domain structure to provide name-to-IP-address resolution on the Internet. An example of an FQDN is bob.acme.com."
    },
    {
       "key":319,
       "value":"FRAD",
       "description":"Frame Relay access device: Any device affording a connection between a LAN and a Frame Relay WAN. See also: Cisco FRAD and FRAS."
    },
    {
       "key":320,
       "value":"fragment",
       "description":"Any portion of a larger packet that has been intentionally segmented into smaller pieces. A packet fragment does not necessarily indicate an error and can be inten- tional. See also: fragmentation."
    },
    {
       "key":321,
       "value":"fragmentation",
       "description":"The process of intentionally segmenting a packet into smaller pieces when sending data over an intermediate network medium that cannot support the larger packet size."
    },
    {
       "key":322,
       "value":"FragmentFree",
       "description":"LAN switch type that reads into the data section of a frame to make sure fragmentation did not occur. Sometimes called modified cut-through."
    },
    {
       "key":323,
       "value":"frame",
       "description":"A logical unit of information sent by the Data Link layer over a transmission medium. The term often refers to the header and trailer, employed for synchronization and error control, that surround the data contained in the unit."
    },
    {
       "key":324,
       "value":"frame filtering",
       "description":"Frame filtering is used on a layer 2 switch to provide more bandwidth. A switch reads the destination hardware address of a frame and then looks for this address in the filter table, which is built by the switch. It then sends the frame out only the port where the hardware address is located, and the other ports do not see the frame."
    },
    {
       "key":325,
       "value":"frame identification (frame tagging)",
       "description":"VLANs can span multiple connected switches, which Cisco calls a switch fabric. Switches within this switch fabric must keep track of frames as they are received on the switch ports, and they must keep track of the VLAN they belong to as the frames traverse this switch fabric. Frame tagging performs this function. Switches can then direct frames to the appropriate port."
    },
    {
       "key":326,
       "value":"Frame Relay",
       "description":"A more efficient replacement of the X.25 protocol (an unrelated packet relay technology that guarantees data delivery). Frame Relay is an industry-standard, shared- access, best-effort, switched Data Link layer encapsulation that services multiple virtual circuits and protocols between connected mechanisms."
    },
    {
       "key":327,
       "value":"Frame Relay bridging",
       "description":"Defined in RFC 1490, this bridging method uses the identical spanning-tree algorithm other bridging operations use but permits packets to be encapsu- lated for transmission across a Frame Relay network."
    },
    {
       "key":328,
       "value":"Frame Relay switching",
       "description":"Packet switching for Frame Relay packets that is provided by a service provider."
    },
    {
       "key":329,
       "value":"frame tagging",
       "description":"See: frame identification."
    },
    {
       "key":330,
       "value":"frame types",
       "description":"Used in LANs to determine how a packet is put on the local network. Ethernet provides four different frame types. These are not compatible with each other, so for two hosts to communicate, they must use the same frame type."
    },
    {
       "key":331,
       "value":"framing",
       "description":"Encapsulation at the Data Link layer of the OSI model. It is called framing because the packet is encapsulated with both a header and a trailer."
    },
    {
       "key":332,
       "value":"frequency",
       "description":"The number of cycles of an alternating current signal per time unit, measured in hertz (cycles per second)."
    },
    {
       "key":333,
       "value":"FSIP",
       "description":"Fast Serial Interface Processor: The Cisco 7000 routers\u0027 default serial interface processor, it provides four or eight high-speed serial ports."
    },
    {
       "key":334,
       "value":"FTP",
       "description":"File Transfer Protocol: The TCP/IP protocol used for transmitting files between network nodes, it supports a broad range of file types and is defined in RFC 959. See also: TFTP."
    },
    {
       "key":335,
       "value":"full-duplex",
       "description":"The capacity to transmit information between a sending station and a receiving unit at the same time. See also: half-duplex."
    },
    {
       "key":336,
       "value":"full mesh",
       "description":"A type of network topology where every node has either a physical or a virtual circuit linking it to every other network node. A full mesh supplies a great deal of redundancy but is typically reserved for network backbones because of its expense. See also: partial mesh."
    },
    {
       "key":337,
       "value":"global command",
       "description":"Cisco term used to define commands that are used to change the router configuration and that affect the whole router. In contrast, an interface command affects only the interface on which it\u0027s configured."
    },
    {
       "key":338,
       "value":"global unicast addresses (2000::/3)",
       "description":"These are your typical publicly routable addresses and they\u0027re the same as in IPv4. Global addresses start at 2000::/3. See also link-local addresses and unique local addresses."
    },
    {
       "key":339,
       "value":"GMII",
       "description":"Gigabit MII: Media Independent Interface that provides 8 bits at a time of data transfer."
    },
    {
       "key":340,
       "value":"GNS",
       "description":"Get Nearest Server: On an IPX network, a request packet sent by a customer for determining the location of the nearest active server of a given type. An IPX network client launches a GNS request to get either a direct answer from a connected server or a response from a router disclosing the location of the service on the internetwork to the GNS. GNS is part of IPX and SAP. See also: IPX and SAP."
    },
    {
       "key":341,
       "value":"grafting",
       "description":"A process that activates an interface that has been deactivated by the pruning process. It is initiated by an IGMP membership report sent to the router."
    },
    {
       "key":342,
       "value":"GRE",
       "description":"Generic Routing Encapsulation: A tunneling protocol created by Cisco with the capacity for encapsulating a wide variety of protocol packet types inside IP tunnels, thereby generating a virtual point-to-point connection to Cisco routers across an IP network at remote points. IP tunneling using GRE permits network expansion across a single-protocol backbone environment by linking multiprotocol subnetworks in a single-protocol backbone environment."
    },
    {
       "key":343,
       "value":"guardband",
       "description":"The unused frequency area found between two communications channels, furnishing the space necessary to avoid interference between the two."
    },
    {
       "key":344,
       "value":"half-duplex",
       "description":"The capacity to transfer data in only one direction at a time between a sending unit and receiving unit. See also: full-duplex."
    },
    {
       "key":345,
       "value":"handshake",
       "description":"Any series of transmissions exchanged between two or more devices on a network to ensure synchronized operations."
    },
    {
       "key":346,
       "value":"H channel",
       "description":"High-speed channel: A full-duplex, ISDN primary rate channel operating at a speed of 384 Kbps. See also: B channel, D channel, and E channel."
    },
    {
       "key":347,
       "value":"HDLC",
       "description":"High-Level Data-Link Control: Using frame characters, including checksums, HDLC designates a method for data encapsulation on synchronous serial links and is the default encapsulation for Cisco routers. HDLC is a bit-oriented synchronous Data Link layer protocol created by ISO and derived from SDLC. However, most HDLC vendor implementations (including Cisco\u0027s) are proprietary. See also: SDLC."
    },
    {
       "key":348,
       "value":"Helper-address",
       "description":"The unicast address specified, which configures the Cisco router to change the client\u0027s local DHCP broadcast request for a service into a directed unicast to the server."
    },
    {
       "key":349,
       "value":"hierarchical addressing",
       "description":"Any addressing plan employing a logical chain of commands to determine location. IP addresses are made up of a hierarchy of network numbers, subnet numbers, and host numbers to direct packets to the appropriate destination."
    },
    {
       "key":350,
       "value":"hierarchy",
       "description":"Term used in defining IP addressing; in hierarchical addressing, some bits are used for networking and some bits for host addressing. Also used in the DNS structure and the Cisco design model."
    },
    {
       "key":351,
       "value":"HIP",
       "description":"HSSI Interface Processor: An interface processor used on Cisco 7000 series routers, providing one HSSI port that supports connections to ATM, SMDS, Frame Relay, or private lines at speeds of up to T3 or E3."
    },
    {
       "key":352,
       "value":"holddown",
       "description":"The state a route is placed in so that routers can neither advertise the route nor accept advertisements about it for a defined time period. Holddowns are used to avoid accepting bad information. The actual information might be good, but it is not trusted. A route is generally placed in holddown when one of its links fails."
    },
    {
       "key":353,
       "value":"hop",
       "description":"The movement of a packet between any two network nodes. See also: hop count."
    },
    {
       "key":354,
       "value":"hop count",
       "description":"A routing metric that calculates the distance between a source and a destina- tion based on the number of routers in the path. RIP employs hop count as its sole metric. See also: hop and RIP."
    },
    {
       "key":355,
       "value":"host address",
       "description":"Logical address configured by an administrator or server on a device. Logically identifies this device on an internetwork."
    },
    {
       "key":356,
       "value":"Host-to-Host layer",
       "description":"Layer in the Internet Protocol suite that is equal to the Transport layer of the OSI model."
    },
    {
       "key":357,
       "value":"HSCI",
       "description":"High-Speed Communication Interface: Developed by Cisco, a single-port interface that provides full-duplex synchronous serial communications capability at speeds of up to 52 Mbps."
    },
    {
       "key":358,
       "value":"HSRP",
       "description":"Hot Standby Router Protocol: A protocol that provides high network availability and nearly instantaneous hardware failover without administrator intervention. It gener- ates a Hot Standby router group, including a lead router that lends its services to any packet being transferred to the Hot Standby address. If the lead router fails, it will be replaced by any of the other routers—the standby routers—that monitor it."
    },
    {
       "key":359,
       "value":"HSSI",
       "description":"High-Speed Serial Interface: A network standard physical connector for high-speed serial linking over a WAN at speeds of up to 52 Mbps."
    },
    {
       "key":360,
       "value":"hubs",
       "description":"Physical layer devices that are really just multiple port repeaters. When an electronic digital signal is received on a port, the signal is re-amplified or regenerated and forwarded out all segments except the segment from which the signal was received."
    },
    {
       "key":361,
       "value":"hybrid routing protocol",
       "description":"Routing protocol that uses the attributes of both distance-vector and link-state. Enhanced Interior Gateway Routing Protocol (Enhanced IGRP) is an example of a hybrid routing protocol."
    },
    {
       "key":362,
       "value":"ICD",
       "description":"International Code Designator: Adapted from the subnetwork model of addressing, this assigns the mapping of Network layer addresses to ATM addresses. ICD is one of two ATM formats for addressing created by the ATM Forum to be utilized with private networks. See also: DCC."
    },
    {
       "key":363,
       "value":"ICMP",
       "description":"Internet Control Message Protocol: Documented in RFC 792, it is a Network layer Internet protocol for the purpose of reporting errors and providing information pertinent to IP packet procedures."
    },
    {
       "key":364,
       "value":"IEEE",
       "description":"Institute of Electrical and Electronics Engineers: A professional organization that, among other activities, defines standards in a number of fields within computing and elec- tronics, including networking and communications. IEEE standards are the predominant LAN standards used today throughout the industry. Many protocols are commonly known by the reference number of the corresponding IEEE standard."
    },
    {
       "key":365,
       "value":"IEEE 802.1",
       "description":"The IEEE committee specification that defines the bridging group. The specifi- cation for STP (Spanning Tree Protocol) is IEEE 802.1D. The STP uses STA (spanning-tree algorithm) to find and prevent network loops in bridged networks. The specification for VLAN trunking is IEEE 802.1q."
    },
    {
       "key":366,
       "value":"IEEE 802.3",
       "description":"The IEEE committee specification that defines the Ethernet group, specifically the original 10 Mbps standard. Ethernet is a LAN protocol that specifies Physical layer and MAC sublayer media access. IEEE 802.3 uses CSMA/CD to provide access for many devices on the same network. Fast Ethernet is defined as 802.3u, and Gigabit Ethernet is defined as 802.3q. See also: CSMA/CD."
    },
    {
       "key":367,
       "value":"IEEE 802.5",
       "description":"IEEE committee that defines Token Ring media access."
    },
    {
       "key":368,
       "value":"IGMP",
       "description":"Internet Group Management Protocol: Employed by IP hosts, the protocol that reports their multicast group memberships to an adjacent multicast router."
    },
    {
       "key":369,
       "value":"IGP",
       "description":"Interior gateway protocol: Any protocol used by an internetwork to exchange routing data within an independent system. Examples include: RIP, EIGRP, and OSPF."
    },
    {
       "key":370,
       "value":"IGRP",
       "description":"Interior Gateway Routing Protocol: Cisco proprietary distance-vector routing algorithm. Upgrade from the RIP protocol."
    },
    {
       "key":371,
       "value":"ILMI",
       "description":"Integrated (or Interim) Local Management Interface. A specification created by the ATM Forum and designated for the incorporation of network-management capability into the ATM UNI. Integrated Local Management Interface cells provide for automatic configu- ration between ATM systems. In LAN emulation, ILMI can provide sufficient information for the ATM end station to find an LECS. In addition, ILMI provides the ATM NSAP (Net- work Service Access Point) prefix information to the end station."
    },
    {
       "key":372,
       "value":"in-band management",
       "description":"In-band management is the management of a network device \u0027through\u0027 the network. Examples include using Simple Network Management Protocol (SNMP) and Telnet directly via the local LAN. Compare with: out-of-band management."
    },
    {
       "key":373,
       "value":"in-band signaling",
       "description":"In-band signaling is the use of the bearer channel to deliver signaling, as with call-waiting in analog POTS lines. This is as opposed to out-of-band signaling, as in the case of the D channel being used to present a second active call in an ISDN circuit."
    },
    {
       "key":374,
       "value":"inside network",
       "description":"In NAT terminology, the inside network is the set of networks that are subject to translation. The outside network refers to all other addresses—usually those located on the Internet."
    },
    {
       "key":375,
       "value":"insured burst",
       "description":"In an ATM network, it is the largest, temporarily permitted data burst exceeding the insured rate on a PVC and not tagged by the traffic policing function for being dropped if network congestion occurs. This insured burst is designated in bytes or cells."
    },
    {
       "key":376,
       "value":"interarea routing",
       "description":"Routing between two or more logical areas. Contrast with: intra-area routing. See also: area."
    },
    {
       "key":377,
       "value":"interface configuration mode",
       "description":"Mode that allows you to configure a Cisco router or switch port with specific information, such as an IP address and mask."
    },
    {
       "key":378,
       "value":"interface processor",
       "description":"Any of several processor modules used with Cisco 7000 series rout- ers. See also: AIP, CIP, EIP, FEIP, HIP, MIP, and TRIP."
    },
    {
       "key":379,
       "value":"Intermediate System–to–Intermediate System (IS-IS)",
       "description":"An OSI link-state hierarchical routing protocol."
    },
    {
       "key":380,
       "value":"internal EIGRP route",
       "description":"These are routes originated within a specific autonomous system by EIGRP routers that are members of the same autonomous system."
    },
    {
       "key":381,
       "value":"Internet",
       "description":"The global \u0027network of networks,\u0027 whose popularity exploded starting in the mid-1990s. Originally a tool for collaborative academic research, it has become a medium for exchanging and distributing information of all kinds. The Internet\u0027s need to link dis- parate computer platforms and technologies has led to the development of uniform proto- cols and standards that have also found widespread use within corporate LANs. See also: TCP/IP and MBONE."
    },
    {
       "key":382,
       "value":"internet",
       "description":"Before the rise of the Internet, this lowercase form was shorthand for \u0027internet- work\u0027 in the generic sense. Now rarely used. See also: internetwork."
    },
    {
       "key":383,
       "value":"Internet layer",
       "description":"Layer in the Internet Protocol suite of protocols that provides network addressing and routing through an internetwork."
    },
    {
       "key":384,
       "value":"Internet Protocol (IP)",
       "description":"Any protocol belonging to the TCP/IP protocol stack. See also: TCP/IP."
    },
    {
       "key":385,
       "value":"internetwork",
       "description":"Any group of networks interconnected by routers and other mechanisms, typically operating as a single entity."
    },
    {
       "key":386,
       "value":"internetworking",
       "description":"Broadly, anything associated with the general task of linking networks to each other. The term encompasses technologies, procedures, and products. When you connect networks to a router, you are creating an internetwork."
    },
    {
       "key":387,
       "value":"intra-area routing",
       "description":"Routing that occurs within a logical area. Contrast with: interarea routing."
    },
    {
       "key":388,
       "value":"Inverse ARP",
       "description":"Inverse Address Resolution Protocol: A technique by which dynamic map- pings are constructed in a network, allowing a device such as a router to locate the logical network address and associate it with a permanent virtual circuit (PVC). Commonly used in Frame Relay to determine the far-end node\u0027s TCP/IP address by sending the Inverse ARP request across the local DLCI."
    },
    {
       "key":389,
       "value":"IP",
       "description":"Internet Protocol: Defined in RFC 791, it is a Network layer protocol that is part of the TCP/IP stack and offers connectionless service. IP furnishes an array of features for address- ing, type-of-service specification, fragmentation and reassembly, and security."
    },
    {
       "key":390,
       "value":"IP address",
       "description":"Often called an Internet address, this is an address uniquely identifying any device (host) on the Internet (or any TCP/IP network). Each address consists of four octets (32 bits), represented as decimal numbers separated by periods (a format known as dotted- decimal). Every address is made up of a network number, an optional subnetwork number, and a host number. The network and subnetwork numbers together are used for routing, while the host number addresses an individual host within the network or subnetwork. The network and subnetwork information are extracted from the IP address using the subnet mask. There are five classes of IP addresses (A–E); Classes A through C allocate different numbers of bits to the network, subnetwork, and host portions of the address. See also: CIDR, IP, and subnet mask."
    },
    {
       "key":391,
       "value":"IPCP",
       "description":"IP Control Program: The protocol used to establish and configure IP over PPP. See also: IP and PPP."
    },
    {
       "key":392,
       "value":"IP multicast",
       "description":"A technique for routing that enables IP traffic to be reproduced from one source to several endpoints or from multiple sources to many destinations. Instead of one packet being transmitted to each individual point of destination, one packet is sent to a multicast group specified by only one IP endpoint address for the group."
    },
    {
       "key":393,
       "value":"IPv6",
       "description":"Internet Protocol Version 6: Defined in RFC 2460, it\u0027s a Network layer routed pro- tocol that is 128 bits in length and offers connectionless service. IPv6 furnishes an array of features for addressing, type-of-service specification, fragmentation and reassembly, and security."
    },
    {
       "key":394,
       "value":"IPX",
       "description":"Internetwork Packet eXchange: Network layer protocol (layer 3) used in Novell NetWare networks for transferring information from servers to workstations. Similar to IP and XNS."
    },
    {
       "key":395,
       "value":"IPXCP",
       "description":"IPX Control Protocol: The protocol used to establish and configure IPX over PPP. See also: IPX and PPP."
    },
    {
       "key":396,
       "value":"IPXWAN",
       "description":"Protocol used for new WAN links to provide and negotiate line options on the link using IPX. After the link is up and the options have been agreed upon by the two end-to-end links, normal IPX transmission begins."
    },
    {
       "key":397,
       "value":"ISDN",
       "description":"Integrated Services Digital Network: Offered as a service by telephone companies, a communication protocol that allows telephone networks to carry data, voice, and other digital traffic. See also: BISDN, BRI, and PRI."
    },
    {
       "key":398,
       "value":"IS-IS",
       "description":"See: Intermediate System–to–Intermediate System (IS-IS)."
    },
    {
       "key":399,
       "value":"ISL",
       "description":"routing Inter-Switch Link routing: A Cisco proprietary method of frame tagging in a switched internetwork. Frame tagging is a way to identify the VLAN membership of a frame as it traverses a switched internetwork."
    },
    {
       "key":400,
       "value":"isochronous transmission",
       "description":"Asynchronous data transfer over a synchronous data link, requir- ing a constant bit rate for reliable transport. Compare with: asynchronous transmission and synchronous transmission."
    },
    {
       "key":401,
       "value":"ITU-T",
       "description":"International Telecommunication Union-Telecommunication Standardization Sec- tor: This is a group of engineers that develops worldwide standards for telecommunications technologies."
    },
    {
       "key":402,
       "value":"Kerberos",
       "description":"An authentication and encryption method that can be used by Cisco routers to ensure that data cannot be \u0027sniffed\u0027 off of the network. Kerberos was developed at MIT and was designed to provide strong security using the Data Encryption Standard (DES) cryptographic algorithm."
    },
    {
       "key":403,
       "value":"LAN",
       "description":"Local area network: Broadly, any network linking two or more computers and related devices within a limited geographical area (up to a few kilometers). LANs are typi- cally high-speed, low-error networks within a company. Cabling and signaling at the Physi- cal and Data Link layers of the OSI are dictated by LAN standards. Ethernet, FDDI, and Token Ring are among the most popular LAN technologies. Compare with: MAN."
    },
    {
       "key":404,
       "value":"LANE",
       "description":"LAN emulation: The technology that allows an ATM network to operate as a LAN backbone. To do so, the ATM network is required to provide multicast and broadcast sup- port, address mapping (MAC to ATM), and SVC management in addition to an operable packet format. Additionally, LANE defines Ethernet and Token Ring ELANs. See also: ELAN."
    },
    {
       "key":405,
       "value":"LAN",
       "description":"switch A high-speed, multiple-interface transparent bridging mechanism for trans- mitting packets between segments of data links, usually referred to specifically as an Eth- ernet switch. LAN switches transfer traffic based on MAC addresses. See also: multilayer switch and store-and-forward packet switching."
    },
    {
       "key":406,
       "value":"LAPB",
       "description":"Link Accessed Procedure, Balanced: A bit-oriented Data Link layer protocol that is part of the X.25 stack and has its origin in SDLC. See also: SDLC and X.25."
    },
    {
       "key":407,
       "value":"LAPD",
       "description":"Link Access Procedure on the D channel: The ISDN Data Link layer protocol used spe- cifically for the D channel and defined by ITU-T Recommendations Q.920 and Q.921. LAPD evolved from LAPB and is created to comply with the signaling requirements of ISDN basic access."
    },
    {
       "key":408,
       "value":"latency",
       "description":"Broadly, the time it takes a data packet to get from one location to another. In specific networking contexts, it can mean either (1) the time elapsed (delay) between the execution of a request for access to a network by a device and the time the mechanism actu- ally is permitted transmission, or (2) the time elapsed between when a mechanism receives a frame and when that frame is forwarded out of the destination port."
    },
    {
       "key":409,
       "value":"layer",
       "description":"Term used in networking to define how the OSI model works to encapsulate data for transmission on the network."
    },
    {
       "key":410,
       "value":"layer 3 switch",
       "description":"See: multilayer switch."
    },
    {
       "key":411,
       "value":"layered architecture",
       "description":"Industry standard way of creating applications to work on a net- work. Layered architecture allows the application developer to make changes in only one layer instead of the whole program."
    },
    {
       "key":412,
       "value":"LCP",
       "description":"Link Control Protocol: The protocol designed to establish, configure, and test data- link connections for use by PPP. See also: PPP."
    },
    {
       "key":413,
       "value":"leaky bucket",
       "description":"An analogy for the generic cell rate algorithm (GCRA) used in ATM networks for checking the conformance of cell flows from a user or network. The bucket\u0027s \u0027hole\u0027 is understood to be the prolonged rate at which cells can be accommodated, and the \u0027depth\u0027 is the tolerance for cell bursts over a certain time period."
    },
    {
       "key":414,
       "value":"learning bridge",
       "description":"A bridge that transparently builds a dynamic database of MAC addresses and the interfaces associated with each address. Transparent bridges help to reduce traffic congestion on the network."
    },
    {
       "key":415,
       "value":"LE ARP",
       "description":"LAN Emulation Address Resolution Protocol: The protocol providing the ATM address that corresponds to a MAC address."
    },
    {
       "key":416,
       "value":"leased line",
       "description":"Permanent connection between two points leased from the telephone companies."
    },
    {
       "key":417,
       "value":"LEC",
       "description":"LAN emulation client: Software providing the emulation of the link layer interface that allows the operation and communication of all higher-level protocols and applications to continue. The LEC runs in all ATM devices, which include hosts, servers, bridges, and routers. See also: ELAN and LES."
    },
    {
       "key":418,
       "value":"LECS",
       "description":"LAN emulation configuration server: An important part of emulated LAN services, providing the configuration data that is furnished upon request from the LES. These ser- vices include address registration for Integrated Local Management Interface (ILMI) sup- port, configuration support for the LES addresses and their corresponding emulated LAN identifiers, and an interface to the emulated LAN. See also: LES and ELAN."
    },
    {
       "key":419,
       "value":"LES",
       "description":"LAN emulation server: The central LANE component that provides the initial con- figuration data for each connecting LEC. The LES typically is located on either an ATM- integrated router or a switch. Responsibilities of the LES include configuration and support for the LEC, address registration for the LEC, database storage and response concerning ATM addresses, and interfacing to the emulated LAN. See also: ELAN, LEC, and LECS."
    },
    {
       "key":420,
       "value":"link",
       "description":"A link is a network or router interface assigned to any given network. When an interface is added to the OSPF process, it\u0027s considered by OSPF to be a link. This link, or interface, will have state information associated with it (up or down) as well as one or more IP addresses."
    },
    {
       "key":421,
       "value":"link-local addresses (FE80::/10)",
       "description":"These are like the Automatic Private IP Address (APIPA) addresses that Microsoft uses to automatically provided addresses in IPv4, in that they\u0027re not meant to be routed. See also global unicast addresses and unique local addresses."
    },
    {
       "key":422,
       "value":"link-state protocols",
       "description":"In link-state protocols, also called shortest-path-first protocols, the routers each create three separate tables. One of these tables keeps track of directly attached neighbors, one determines the topology of the entire internetwork, and one is used as the routing table. Link-state routers know more about the internetwork than any distance- vector routing protocol."
    },
    {
       "key":423,
       "value":"link-state routing algorithm",
       "description":"A routing algorithm that allows each router to broadcast or multicast information regarding the cost of reaching all its neighbors to every node in the internetwork. Link-state algorithms provide a consistent view of the network and are there- fore not vulnerable to routing loops. However, this loop-free network is achieved at the cost of somewhat greater difficulty in computation and more widespread traffic (compared with distance-vector routing algorithms). See also: distance-vector routing algorithm."
    },
    {
       "key":424,
       "value":"LLAP",
       "description":"LocalTalk Link Access Protocol: In a LocalTalk environment, the data-link-level protocol that manages node-to-node delivery of data. This protocol provides node address- ing and management of bus access, and it also controls data sending and receiving to ensure packet length and integrity."
    },
    {
       "key":425,
       "value":"LLC",
       "description":"Logical Link Control: Defined by the IEEE, the higher of two Data Link layer sublay- ers. LLC is responsible for error detection (but not correction), flow control, framing, and software-sublayer addressing. The predominant LLC protocol, IEEE 802.2, defines both connectionless and connection-oriented operations. See also: Data Link layer and MAC."
    },
    {
       "key":426,
       "value":"LMI",
       "description":"Local Management Interface: An enhancement to the original Frame Relay specifica- tion. Among the features it provides are a keepalive mechanism, a multicast mechanism, global addressing, and a status mechanism."
    },
    {
       "key":427,
       "value":"LNNI",
       "description":"LAN Emulation Network-to-Network Interface: In the Phase 2 LANE specifica- tion, an interface that supports communication between the server components within one ELAN."
    },
    {
       "key":428,
       "value":"load",
       "description":"Like IGRP, EIGRP uses only bandwidth and delay of the line to determine the best path to a remote network by default. However, EIGRP can use a combination of band- width, delay, load, and reliability in its quest to find the best path to a remote network. Load refers to the amount of data on the link."
    },
    {
       "key":429,
       "value":"load balancing",
       "description":"The act of balancing packet load over multiple links to the same remote network."
    },
    {
       "key":430,
       "value":"local explorer packet",
       "description":"In a Token Ring SRB network, a packet generated by an end system to find a host linked to the local ring. If no local host can be found, the end system will pro- duce one of two solutions: a spanning explorer packet or an all-routes explorer packet."
    },
    {
       "key":431,
       "value":"local loop",
       "description":"Connection from a demarcation point to the closest switching office."
    },
    {
       "key":432,
       "value":"LocalTalk",
       "description":"Utilizing CSMA/CD, in addition to supporting data transmission at speeds of 230.4 Kbps, LocalTalk is Apple Computer\u0027s proprietary baseband protocol, operating at the Data Link and Physical layers of the OSI reference model."
    },
    {
       "key":433,
       "value":"logical address",
       "description":"Network layer address that defines how data is sent from one network to another. Examples of logical addresses are IP and IPX."
    },
    {
       "key":434,
       "value":"loop avoidance",
       "description":"If multiple connections between switches are created for redundancy purposes, network loops can occur. Spanning Tree Protocol (STP) is used to stop network loops while still permitting redundancy."
    },
    {
       "key":435,
       "value":"loopback address",
       "description":"The IP address 127.0.0.1 is called the diagnostic or loopback address, and if you get a successful ping to this address, your IP stack is then considered to be ini- tialized. If it fails, then you have an IP stack failure and need to reinstall TCP/IP on the host."
    },
    {
       "key":436,
       "value":"loopback interface",
       "description":"Loopback interfaces are logical interfaces, which means they are not real router interfaces. They can be used for diagnostic purposes as well as OSPF configura- tion."
    },
    {
       "key":437,
       "value":"LPD",
       "description":"Line Printer Daemon: Used in the Unix world to allow printing to an IP address."
    },
    {
       "key":438,
       "value":"LSA",
       "description":"Link-State Advertisement: Contained inside of link-state packets (LSPs), these adver- tisements are usually multicast packets that contain information about neighbors and path costs and are employed by link-state protocols. Receiving routers use LSAs to maintain their link-state databases and, ultimately, routing tables. Most often associated with OSPF."
    },
    {
       "key":439,
       "value":"LUNI",
       "description":"LAN Emulation User-to-Network Interface: Defining the interface between the LAN emulation client (LEC) and the LAN emulation server (LES), LUNI is the ATM Forum\u0027s standard for LAN emulation on ATM networks. See also: LES and LECS."
    },
    {
       "key":440,
       "value":"MAC",
       "description":"Media Access Control: The lower sublayer in the Data Link layer, it is responsible for hardware addressing, media access, and error detection of frames. See also: Data Link layer and LLC."
    },
    {
       "key":441,
       "value":"MAC address",
       "description":"A Data Link layer hardware address that every port or device needs in order to connect to a LAN segment. These addresses are used by various devices in the network for accurate location of logical addresses. MAC addresses are defined by the IEEE standard and their length is six characters, typically using the burned-in address (BIA) of the local LAN interface. Variously called hardware address, physical address, burned-in address, or MAC layer address."
    },
    {
       "key":442,
       "value":"MacIP",
       "description":"In AppleTalk, the Network layer protocol encapsulating IP packets in Datagram Delivery Protocol (DDP) packets. MacIP also supplies substitute ARP services."
    },
    {
       "key":443,
       "value":"MAN",
       "description":"Metropolitan area network: Any network that encompasses a metropolitan area; that is, an area typically larger than a LAN but smaller than a WAN. See also: LAN and WAN."
    },
    {
       "key":444,
       "value":"Manchester encoding",
       "description":"A method for digital coding in which a mid-bit-time transition is employed for clocking and a 1 (one) is denoted by a high voltage level during the first half of the bit time. This scheme is used by Ethernet and IEEE 802.3."
    },
    {
       "key":445,
       "value":"maximum burst",
       "description":"Specified in bytes or cells, the largest burst of information exceeding the insured rate that will be permitted on an ATM permanent virtual connection for a short time and will not be dropped even if it goes over the specified maximum rate. Compare with: insured burst. See also: maximum rate."
    },
    {
       "key":446,
       "value":"maximum hop count",
       "description":"Number of routers a packet is allowed to pass before it is termi- nated. This is created to prevent a packet from circling a network forever."
    },
    {
       "key":447,
       "value":"maximum rate",
       "description":"The maximum permitted data throughput on a particular virtual circuit, equal to the total of insured and uninsured traffic from the traffic source. Should traffic congestion occur, uninsured information may be deleted from the path. Measured in bits or cells per second, the maximum rate represents the highest throughput of data the virtual circuit is ever able to deliver and cannot exceed the media rate. Compare with: excess rate. See also: maximum burst."
    },
    {
       "key":448,
       "value":"MBONE",
       "description":"The multicast backbone of the Internet, it is a virtual multicast network made up of multicast LANs, including point-to-point tunnels interconnecting them."
    },
    {
       "key":449,
       "value":"MBS",
       "description":"Maximum burst size: In an ATM signaling message, this metric, coded as a number of cells, is used to convey the burst tolerance."
    },
    {
       "key":450,
       "value":"MCDV",
       "description":"Maximum cell delay variation: The maximum two-point CDV objective across a link or node for the identified service category in an ATM network."
    },
    {
       "key":451,
       "value":"MCLR",
       "description":"Maximum cell loss ratio: The maximum ratio of cells in an ATM network that fail to transit a link or node compared with the total number of cells that arrive at the link or node. MCLR is one of four link metrics that are exchanged using PTSPs to verify the avail- able resources of an ATM network. The MCLR applies to cells in VBR and CBR traffic classes whose CLP bit is set to zero. See also: CBR, CLP, and VBR."
    },
    {
       "key":452,
       "value":"MCR",
       "description":"Minimum cell rate: A parameter determined by the ATM Forum for traffic manage- ment of the ATM networks. MCR is specifically defined for ABR transmissions and speci- fies the minimum value for the allowed cell rate (ACR). See also: ACR and PCR."
    },
    {
       "key":453,
       "value":"MCT",
       "description":"Maximum cell Transfer delay: In an ATM network, the total of the maximum cell delay variation and the fixed delay across the link or node. MCTD is one of four link metrics that are exchanged using PNNI topology state packets to verify the available resources of an ATM network. There is one MCTD value assigned to each traffic class. See also: MCDV."
    },
    {
       "key":454,
       "value":"media translation",
       "description":"A router property that allows two different types of LANs to communicate—for example, Ethernet to Token Ring."
    },
    {
       "key":455,
       "value":"MIB",
       "description":"Management information base: Used with SNMP management software to gather information from remote devices. The management station can poll the remote device for information, or the MIB running on the remote station can be programmed to send infor- mation on a regular basis."
    },
    {
       "key":456,
       "value":"MII",
       "description":"Media Independent Interface: Used in Fast Ethernet and Gigabit Ethernet to provide faster bit transfer rates of 4 and 8 bits at a time. Contrast to AUI interface, which is 1 bit at a time."
    },
    {
       "key":457,
       "value":"MIP",
       "description":"Multichannel Interface Processor: The resident interface processor on Cisco 7000 series routers, providing up to two channelized T1 or E1 connections by serial cables connected to a CSU. The two controllers are capable of providing 24 T1 or 30 E1 channel groups, with each group being introduced to the system as a serial interface that can be configured individually."
    },
    {
       "key":458,
       "value":"mips",
       "description":"Millions of instructions per second: A measure of processor speed."
    },
    {
       "key":459,
       "value":"MLP",
       "description":"Multilink PPP: A technique used to split, recombine, and sequence datagrams across numerous logical data links."
    },
    {
       "key":460,
       "value":"MMP",
       "description":"Multichassis Multilink PPP: A protocol that supplies MLP support across multiple routers and access servers. MMP enables several routers and access servers to work as a sin- gle, large dial-up pool with one network address and ISDN access number. MMP success- fully supports packet fragmenting and reassembly when the user connection is split between two physical access devices."
    },
    {
       "key":461,
       "value":"modem",
       "description":"Modulator-demodulator: A device that converts digital signals to analog and vice versa so that digital information can be transmitted over analog communication facili- ties such as voice-grade telephone lines. This is achieved by converting digital signals at the source to analog for transmission and reconverting the analog signals back into digital form at the destination. See also: modulation and demodulation."
    },
    {
       "key":462,
       "value":"modem eliminator",
       "description":"A mechanism that makes possible a connection between two DTE devices without modems by simulating the commands and physical signaling required."
    },
    {
       "key":463,
       "value":"modulation",
       "description":"The process of modifying some characteristic of an electrical signal, such as amplitude (AM) or frequency (FM), in order to represent digital or analog information. See also: AM."
    },
    {
       "key":464,
       "value":"MOSPF",
       "description":"Multicast OSPF: An extension of the OSPF unicast protocol that enables IP multi- cast routing within the domain. See also: OSPF."
    },
    {
       "key":465,
       "value":"MPOA",
       "description":"Multiprotocol over ATM: A protocol that represents an effort by the ATM Forum to standardize how existing and future Network layer protocols such as IP, IPv6, Apple- Talk, and IPX run over an ATM network with directly attached hosts, routers, and multi- layer LAN switches."
    },
    {
       "key":466,
       "value":"MTU",
       "description":"Maximum transmission unit: The largest packet size, measured in bytes, that an interface can handle."
    },
    {
       "key":467,
       "value":"multicast",
       "description":"Broadly, any communication between a single sender and multiple receivers. Unlike broadcast messages, which are sent to all addresses on a network, multicast messages are sent to a defined subset of the network addresses; this subset has a group multicast address, which is specified in the packet\u0027s destination address field. See also: directed broadcast."
    },
    {
       "key":468,
       "value":"multicast address",
       "description":"A single address that points to more than one device on the network by specifying a special nonexistent MAC address transmitted in that particular multicast protocol. Identical to a group address. See also: multicast."
    },
    {
       "key":469,
       "value":"multicast group",
       "description":"Multicast works by sending messages or data to IP multicast group addresses. The group is a defined set of users or hosts that are allowed to read or view the data sent via multicast."
    },
    {
       "key":470,
       "value":"multicast send VCC",
       "description":"A two-directional point-to-point virtual control connection (VCC) arranged by an LEC to a BUS, it is one of the three types of informational links specified by phase 1 LANE. See also: control distribute VCC and control direct VCC."
    },
    {
       "key":471,
       "value":"multilayer switch",
       "description":"A highly specialized, high-speed, hardware-based type of LAN router, the device filters and forwards packets based on their layer 2 MAC addresses and layer 3 network addresses. It\u0027s possible that even layer 4 can be read. Sometimes called a layer 3 switch. See also: LAN switch."
    },
    {
       "key":472,
       "value":"multilink",
       "description":"Used to combine multiple async or ISDN links to provide combined bandwidth."
    },
    {
       "key":473,
       "value":"multiplexing",
       "description":"The process of converting several logical signals into a single physical signal for transmission across one physical channel. Contrast with: demultiplexing."
    },
    {
       "key":474,
       "value":"NAK",
       "description":"Negative acknowledgment: A response sent from a receiver telling the sender that the information was not received or contained errors. Compare with: acknowledgment."
    },
    {
       "key":475,
       "value":"named access list",
       "description":"Used in both standard and extended lists to help with administration of access lists by allowing you to name the lists instead of using numbers. This also allows you to change a single line of an access list, which isn\u0027t possible in regular, numbered access lists."
    },
    {
       "key":476,
       "value":"NAT",
       "description":"Network Address Translation: An algorithm instrumental in minimizing the require- ment for globally unique IP addresses, permitting an organization whose addresses are not all globally unique to connect to the Internet nevertheless by translating those addresses into globally routable address space."
    },
    {
       "key":477,
       "value":"native VLAN",
       "description":"Cisco switches all have a native VLAN called VLAN 1. This cannot be deleted or changed in any way. All switch ports are in VLAN 1 by default."
    },
    {
       "key":478,
       "value":"NBP",
       "description":"Name Binding Protocol: In AppleTalk, the transport-level protocol that interprets a socket client\u0027s name, entered as a character string, into the corresponding DDP address."
    },
    {
       "key":479,
       "value":"NBP",
       "description":"gives AppleTalk protocols the capacity to discern user-defined zones and names of mechanisms by showing and keeping translation tables that map names to their correspond- ing socket addresses."
    },
    {
       "key":480,
       "value":"Neighbor Discovery Protocol (ND)",
       "description":"Finds the address of other devices on a local link. The Address Resolution Protocol (ARP) is used to perform this function for IPv4, but that has been renamed Neighbor Discovery (ND) in ICMPv6."
    },
    {
       "key":481,
       "value":"neighboring routers",
       "description":"Two routers in OSPF that have interfaces to a common network. On networks with multi-access, these neighboring routers are dynamically discovered using the Hello protocol of OSPF."
    },
    {
       "key":482,
       "value":"neighbors",
       "description":"EIGRP and OSPF routers become neighbors when each router sees the other\u0027s Hello packets."
    },
    {
       "key":483,
       "value":"neighborship table",
       "description":"In OSPF and EIGRP routing protocols, each router keeps state information about adjacent neighbors. When newly discovered neighbors are learned, the address and interface of the neighbor is recorded. This information is stored in the neighbor data structure and the neighbor table holds these entries. A neighborship table can also be referred to as a neighbor table or a neighborship database."
    },
    {
       "key":484,
       "value":"NetBEUI",
       "description":"NetBIOS Extended User Interface: An improved version of the NetBIOS proto- col used in a number of network operating systems—including LAN Manager, Windows NT, LAN Server, and Windows for Workgroups—and implementing the OSI LLC2 proto- col. NetBEUI formalizes the transport frame not standardized in NetBIOS and adds more functions. See also: OSI."
    },
    {
       "key":485,
       "value":"NetBIOS",
       "description":"Network Basic Input/Output System: The API employed by applications resid- ing on an IBM LAN to ask for services, such as session termination or information transfer, from lower-level network processes."
    },
    {
       "key":486,
       "value":"NetView",
       "description":"A mainframe network product from IBM used for monitoring SNA (Systems Network Architecture) networks. It runs as a VTAM (Virtual Telecommunications Access Method) application."
    },
    {
       "key":487,
       "value":"NetWare",
       "description":"A widely used NOS created by Novell and providing a number of distributed network services and remote file access."
    },
    {
       "key":488,
       "value":"Network Access layer",
       "description":"Bottom layer in the Internet Protocol suite; it provides media access to packets."
    },
    {
       "key":489,
       "value":"network address",
       "description":"Used with the logical network addresses to identify the network seg- ment in an internetwork. Logical addresses are hierarchical in nature and have at least two parts: network and host. An example of a hierarchical address is 172.16.10.5, where 172.16 is the network and 10.5 is the host address."
    },
    {
       "key":490,
       "value":"Network Control Protocol",
       "description":"A method of establishing and configuring different Network layer protocols. NCP is designed to allow the simultaneous use of multiple Network layer protocols. Some examples of protocols here are IPCP (Internet Protocol Control Protocol) and IPXCP (Internetwork Packet Exchange Control Protocol)."
    },
    {
       "key":491,
       "value":"Network layer",
       "description":"In the OSI reference model, it is layer 3—the layer in which routing is implemented, enabling connections and path selection between two end systems. See also: Application layer, Data Link layer, Physical layer, Presentation layer, Session layer, and Transport layer."
    },
    {
       "key":492,
       "value":"network segmentation",
       "description":"Breaking up a large network into smaller networks. Routers, switches, and bridges are used to create network segmentation."
    },
    {
       "key":493,
       "value":"NFS",
       "description":"Network File System: One of the protocols in Sun Microsystems\u0027s widely used file system protocol suite, allowing remote file access across a network. The name is loosely used to refer to the entire Sun protocol suite, which also includes RPC, XDR (External Data Representation), and other protocols."
    },
    {
       "key":494,
       "value":"NHRP",
       "description":"Next Hop Resolution Protocol: In a nonbroadcast multi-access (NBMA) network, the protocol employed by routers in order to dynamically locate MAC addresses of various hosts and routers. It enables systems to communicate directly without requiring an intermediate hop, thus facilitating increased performance in ATM, Frame Relay, X.25, and SMDS systems."
    },
    {
       "key":495,
       "value":"NHS",
       "description":"Next Hop Server: Defined by the NHRP protocol, this server maintains the next-hop resolution cache tables, listing IP-to-ATM address maps of related nodes and nodes that can be reached through routers served by the NHS."
    },
    {
       "key":496,
       "value":"nibble",
       "description":"Four bits."
    },
    {
       "key":497,
       "value":"NIC",
       "description":"Network interface card: An electronic circuit board placed in a computer. The NIC provides network communication to a LAN."
    },
    {
       "key":498,
       "value":"NLSP",
       "description":"NetWare Link Services Protocol: Novell\u0027s link-state routing protocol, based on the IS-IS model."
    },
    {
       "key":499,
       "value":"NMP",
       "description":"Network Management Processor: A Catalyst 5000 switch processor module used to control and monitor the switch."
    },
    {
       "key":500,
       "value":"node address",
       "description":"Used to identify a specific device in an internetwork. Can be a hardware address, which is burned into the network interface card, or a logical network address, which an administrator or server assigns to the node."
    },
    {
       "key":501,
       "value":"nonbroadcast multi-access (NBMA) networks",
       "description":"Nonbroadcast multi-access (NBMA) networks are types such as Frame Relay, X.25, and Asynchronous Transfer Mode (ATM). These networks allow for multi-access but have no broadcast ability like Ethernet. So NBMA networks require special OSPF configuration to function properly and neighbor relationships must be defined."
    },
    {
       "key":502,
       "value":"non-designated port",
       "description":"A switch port that will not forward frames in order to prevent a switching loop. Spanning Tree Protocol (STP) is responsible for deciding whether a port is designated (forwarding) or non-designated (blocking)."
    },
    {
       "key":503,
       "value":"non-stub area",
       "description":"In OSPF, a resource-consuming area carrying a default route, intra-area routes, interarea routes, static routes, and external routes. Non-stub areas are the only areas that can have virtual links configured across them and exclusively contain an autonomous system border router (ASBR). Compare with: stub area. See also: ASBR and OSPF."
    },
    {
       "key":504,
       "value":"NRZ",
       "description":"Nonreturn to zero: One of several encoding schemes for transmitting digital data. NRZ signals sustain constant levels of voltage with no signal shifting (no return to zero- voltage level) during a bit interval. If there is a series of bits with the same value (1 or 0), there will be no state change. The signal is not self-clocking. See also: NRZI."
    },
    {
       "key":505,
       "value":"NRZI",
       "description":"Nonreturn to zero inverted: One of several encoding schemes for transmitting digi- tal data. A transition in voltage level (either from high to low or vice versa) at the beginning of a bit interval is interpreted as a value of 1; the absence of a transition is interpreted as a 0. Thus, the voltage assigned to each value is continually inverted. NRZI signals are not self- clocking. See also: NRZ."
    },
    {
       "key":506,
       "value":"NT",
       "description":"Network termination: A point in an ISDN network. See: NT1 and NT2."
    },
    {
       "key":507,
       "value":"NT1",
       "description":"NT1 is the device that converts the two-wire \u0027U\u0027 interface to the four-wire \u0027S/T.\u0027"
    },
    {
       "key":508,
       "value":"NT2",
       "description":"NT2 is an ISDN-compliant switching device, like a PBX, that splits the \u0027S/T\u0027 bus into two separate, but electrically equivalent, interfaces. The \u0027T\u0027 interface connects to the NT1, while the \u0027S\u0027 interface connects to TE1 devices."
    },
    {
       "key":509,
       "value":"NVRAM",
       "description":"Nonvolatile RAM: Random-access memory that keeps its contents intact while power is turned off."
    },
    {
       "key":510,
       "value":"OC",
       "description":"Optical Carrier: A series of physical protocols, designated as OC-1, OC-2, OC-3, and so on, for SONET optical signal transmissions. OC signal levels place STS frames on a mul- timode fiber-optic line at various speeds, of which 51.84 Mbps is the lowest (OC-1). Each subsequent protocol runs at a speed divisible by 51.84. See also: SONET."
    },
    {
       "key":511,
       "value":"octet",
       "description":"Base-8 numbering system used to identify a section of a dotted-decimal IP address. Also referred to as a byte."
    },
    {
       "key":512,
       "value":"ones density",
       "description":"Also known as pulse density, this is a method of signal clocking. The CSU/ DSU retrieves the clocking information from data that passes through it. For this scheme to work, the data needs to be encoded to contain at least one binary 1 for every 8 bits trans- mitted. See also: CSU /DSU."
    },
    {
       "key":513,
       "value":"OSI",
       "description":"Open Systems Interconnection: International standardization program designed by ISO and ITU-T for the development of data networking standards that make multivendor equipment interoperability a reality."
    },
    {
       "key":514,
       "value":"OSI reference model",
       "description":"Open Systems Interconnection reference model: A conceptual model defined by the International Organization for Standardization (ISO), describing how any combination of devices can be connected for the purpose of communication. The OSI model divides the task into seven functional layers, forming a hierarchy with the appli- cations at the top and the physical medium at the bottom, and it defines the functions each layer must provide. See also: Application layer, Data Link layer, Network layer, Physical layer, Presentation layer, Session layer, and Transport layer."
    },
    {
       "key":515,
       "value":"OSPF",
       "description":"Open Shortest Path First: A link-state, hierarchical routing algorithm derived from an earlier version of the IS-IS protocol. Its features include multipath routing, load balanc- ing, and least-cost routing. OSPF is the suggested successor to RIP in the Internet environ- ment. See also: Enhanced IGRP, IGP, and IP."
    },
    {
       "key":516,
       "value":"OSPF area",
       "description":"An OSPF area is a grouping of contiguous networks and routers. All routers in the same area share a common area ID. Because a router can be a member of more than one area at a time, the area ID is associated with specific interfaces on the router. This would allow some interfaces to belong to area 1 while the remaining interfaces can belong to area 0. All of the routers within the same area have the same topology table."
    },
    {
       "key":517,
       "value":"OUI",
       "description":"Organizationally unique identifier: Code assigned by the IEEE to an organization that makes network interface cards. The organization then puts this OUI on each and every card it manufactures. The OUI is 3 bytes (24 bits) long. The manufacturer then adds a 3-byte identifier to uniquely identify the host. The total length of the address is 48 bits (6 bytes) and is called a hardware address or MAC address."
    },
    {
       "key":518,
       "value":"out-of-band management",
       "description":"Management \u0027outside\u0027 of the network\u0027s physical channels— for example, using a console connection not directly interfaced through the local LAN or WAN or a dial-in modem. Compare to: in-band management."
    },
    {
       "key":519,
       "value":"out-of-band signaling",
       "description":"Within a network, any transmission that uses physical channels or frequencies separate from those ordinarily used for data transfer."
    },
    {
       "key":520,
       "value":"outside network",
       "description":"In NAT terminology, the inside network is the set of networks that are subject to translation. The outside network refers to all other addresses—usually those located on the Internet."
    },
    {
       "key":521,
       "value":"packet",
       "description":"In data communications, the basic logical unit of information transferred. A packet consists of a certain number of data bytes wrapped or encapsulated in headers and/ or trailers that contain information about where the packet came from, where it\u0027s going, and so on. The various protocols involved in sending a transmission add their own layers of header information, which the corresponding protocols in receiving devices then interpret."
    },
    {
       "key":522,
       "value":"packet switch",
       "description":"A physical device that makes it possible for a communication channel to share several connections; its functions include finding the most efficient transmission path for packets."
    },
    {
       "key":523,
       "value":"packet switching",
       "description":"A networking technology based on the transmission of data in packets. Dividing a continuous stream of data into small units—packets—enables data from multiple devices on a network to share the same communication channel simultaneously but also requires the use of precise routing information."
    },
    {
       "key":524,
       "value":"PAP",
       "description":"Password Authentication Protocol: In Point-to-Point Protocol (PPP) networks, a method of validating connection requests. The requesting (remote) device must send an authentication request containing a password and ID to the local router when attempting to connect. Unlike the more secure CHAP (Challenge Handshake Authentication Protocol), PAP sends the password unencrypted and does not attempt to verify whether the user is authorized to access the requested resource; it merely identifies the remote end. See also: CHAP."
    },
    {
       "key":525,
       "value":"parity checking",
       "description":"A method of error checking in data transmissions. An extra bit (the par- ity bit) is added to each character or data word so that the sum of the bits will be either an odd number (in odd parity) or an even number (even parity)."
    },
    {
       "key":526,
       "value":"partial mesh",
       "description":"A type of network topology in which some network nodes form a full mesh (where every node has either a physical or a virtual circuit linking it to every other network node) but others are attached to only one or two nodes in the network. A typical use of partial-mesh topology is in peripheral networks linked to a fully meshed backbone. See also: full mesh."
    },
    {
       "key":527,
       "value":"passive state",
       "description":"Regarding an EIGRP routing table, a route is considered to be in the passive state when a router is not performing a route convergence."
    },
    {
       "key":528,
       "value":"PAT",
       "description":"Port Address Translation: This process allows a single IP address to represent multiple resources by altering the source TCP or UDP port number."
    },
    {
       "key":529,
       "value":"PCM",
       "description":"Pulse code modulation: Process by which an analog signal is converted into digital information."
    },
    {
       "key":530,
       "value":"PC",
       "description":"R Peak cell rate: As defined by the ATM Forum, the parameter specifying, in cells per second, the maximum rate at which a source may transmit."
    },
    {
       "key":531,
       "value":"PDN",
       "description":"Public data network: Generally for a fee, a PDN offers the public access to a com- puter communication network operated by private concerns or government agencies. Small organizations can take advantage of PDNs, aiding them to create WANs without investing in long-distance equipment and circuitry."
    },
    {
       "key":532,
       "value":"PDU",
       "description":"Protocol data unit: The processes at each layer of the OSI model. PDUs at the Trans- port layer are called segments, PDUs at the Network layer are called packets or datagrams, and PDUs at the Data Link layer are called frames. The Physical layer uses bits."
    },
    {
       "key":533,
       "value":"PGP",
       "description":"Pretty Good Privacy: A popular public-key/private-key encryption application offer- ing protected transfer of files and messages."
    },
    {
       "key":534,
       "value":"phantom router",
       "description":"Used in a Hot Standby Routing Protocol (HSRP) network to provide an IP default gateway address to hosts."
    },
    {
       "key":535,
       "value":"Physical layer",
       "description":"The lowest layer—layer 1—in the OSI reference model, it is responsible for converting data frames from the Data Link layer (layer 2) into electrical signals. Physical layer protocols and standards define, for example, the type of cable and connectors to be used, including their pin assignments and the encoding scheme for signaling 0 and 1 values. See also: Application layer, Data Link layer, Network layer, Presentation layer, Session layer, and Transport layer."
    },
    {
       "key":536,
       "value":"PIM",
       "description":"Protocol Independent Multicast: A multicast protocol that handles the IGMP requests as well as requests for multicast data forwarding."
    },
    {
       "key":537,
       "value":"PIM-DM",
       "description":"Protocol Independent Multicast Dense Mode: PIM-DM utilizes the unicast route table and relies on the source root distribution architecture for multicast data forwarding."
    },
    {
       "key":538,
       "value":"PIM-SM",
       "description":"Protocol Independent Multicast Sparse Mode: PIM-SM utilizes the unicast route table and relies on the shared root distribution architecture for multicast data forwarding."
    },
    {
       "key":539,
       "value":"Ping",
       "description":"Packet Internet Groper: A Unix-based Internet diagnostic tool consisting of a mes- sage sent to test the accessibility of a particular device on the IP network. The term\u0027s abbre- viation reflects the underlying metaphor of submarine sonar. Just as the sonar operator sends out a signal and waits to hear it echo (\u0027ping\u0027) back from a submerged object, the network user can ping another node on the network and wait to see if it responds."
    },
    {
       "key":540,
       "value":"pinhole congestion",
       "description":"A problem associated with distance-vector routing protocols if more than one connection to a remote network is known but they are different bandwidths."
    },
    {
       "key":541,
       "value":"plesiochronous",
       "description":"Nearly synchronous, except that clocking comes from an outside source instead of being embedded within the signal as in synchronous transmissions."
    },
    {
       "key":542,
       "value":"PLP",
       "description":"Packet Level Protocol: Occasionally called X.25 level 3 or X.25 Protocol, a Network layer protocol that is part of the X.25 stack."
    },
    {
       "key":543,
       "value":"PNNI",
       "description":"Private Network-Network Interface: An ATM Forum specification for offering topology data used for the calculation of paths through the network among switches and groups of switches. It is based on well-known link-state routing procedures and allows for automatic configuration in networks whose addressing scheme is determined by the topol- ogy."
    },
    {
       "key":544,
       "value":"point-to-multipoint connection",
       "description":"In ATM, a communication path going only one way, connecting a single system at the starting point, called the root node, to systems at multiple points of destination, called leaves. See also: point-to-point connection."
    },
    {
       "key":545,
       "value":"point-to-point connection",
       "description":"In ATM, a channel of communication that can be directed either one way or two ways between two ATM end systems. Also refers to a point-to-point WAN serial connection. See also: point-to-multipoint connection."
    },
    {
       "key":546,
       "value":"poison reverse updates",
       "description":"These update messages are transmitted by a router back to the originator (thus ignoring the split-horizon rule) after route poisoning has occurred. Typically used with DV routing protocols in order to overcome large routing loops and offer explicit information when a subnet or network is not accessible (instead of merely suggesting that the network is unreachable by not including it in updates). See also: route poisoning."
    },
    {
       "key":547,
       "value":"polling",
       "description":"The procedure of orderly inquiry used by a primary network mechanism to determine if secondary devices have data to transmit. A message is sent to each secondary, granting the secondary the right to transmit."
    },
    {
       "key":548,
       "value":"POP",
       "description":"(1) Point of presence: The physical location where an interexchange carrier has placed equipment to interconnect with a local exchange carrier. (2) Post Office Protocol: A protocol used by client email applications for recovery of mail from a mail server."
    },
    {
       "key":549,
       "value":"port security",
       "description":"Used with layer 2 switches to provide some security. Not typically used in production because it is difficult to manage. Allows only certain frames to traverse adminis- trator-assigned segments."
    },
    {
       "key":550,
       "value":"port numbers",
       "description":"Used at the Transport layer with TCP and UDP to keep track of host-to- host virtual circuits."
    },
    {
       "key":551,
       "value":"positive acknowledgment with retransmission",
       "description":"A connection-oriented session that provides acknowledgment and retransmission of the data if it is not acknowledged by the receiving host within a certain time frame."
    },
    {
       "key":552,
       "value":"POTS",
       "description":"Plain old telephone service: This refers to the traditional analog phone service that is found in most installations."
    },
    {
       "key":553,
       "value":"PPP",
       "description":"Point-to-Point Protocol: The protocol most commonly used for dial-up Internet access, superseding the earlier SLIP. Its features include address notification, authentication via CHAP or PAP, support for multiple protocols, and link monitoring. PPP has two layers: the Link Control Protocol (LCP) establishes, configures, and tests a link, and then any of various Network Control Protocols (NCPs) transport traffic for a specific protocol suite, such as IPX. See also: CHAP, PAP, and SLIP."
    },
    {
       "key":554,
       "value":"prefix routing",
       "description":"Method of defining how many bits are used in a subnet and how this infor- mation is sent in a routing update. For example, RIP version 1 does not send subnet mask information in the route updates. However, RIP version 2 does. This means that RIPv2 updates will send /24, /25, /26, etc. with a route update, which RIPv1 will not."
    },
    {
       "key":555,
       "value":"Presentation layer",
       "description":"Layer 6 of the OSI reference model, it defines how data is formatted, presented, encoded, and converted for use by software at the Application layer. See also: Application layer, Data Link layer, Network layer, Physical layer, Session layer, and Transport layer."
    },
    {
       "key":556,
       "value":"PRI",
       "description":"Primary Rate Interface: A type of ISDN connection between a PBX and a long-distance carrier. It is made up of a single 64 Kbps D channel in addition to 23 (T1) or 30 (E1) B channels. See also: ISDN."
    },
    {
       "key":557,
       "value":"priority queuing",
       "description":"A routing function in which frames temporarily placed in an interface output queue are assigned priorities based on traits such as packet size or type of interface."
    },
    {
       "key":558,
       "value":"privileged mode",
       "description":"Command-line EXEC mode used in Cisco routers and switches that pro- vides both viewing and changing of configurations."
    },
    {
       "key":559,
       "value":"Process/Application layer",
       "description":"Upper layer in the Internet Protocol stack. Responsible for network services."
    },
    {
       "key":560,
       "value":"process switching",
       "description":"As a packet arrives on a router to be forwarded, it\u0027s copied to the rout- er\u0027s process buffer, and the router performs a lookup on the layer 3 address. Using the route table, an exit interface is associated with the destination address. The processor forwards the packet with the added new information to the exit interface, while the router initializes the fast-switching cache. Subsequent packets bound for the same destination address follow the same path as the first packet."
    },
    {
       "key":561,
       "value":"PROM",
       "description":"Programmable read-only memory: ROM that is programmable only once, using special equipment. Compare with: EPROM and EEPROM."
    },
    {
       "key":562,
       "value":"propagation delay",
       "description":"The time it takes data to traverse a network from its source to its destination."
    },
    {
       "key":563,
       "value":"protocol",
       "description":"In networking, the specification of a set of rules for a particular type of commu- nication. The term is also used to refer to the software that implements a protocol."
    },
    {
       "key":564,
       "value":"protocol-dependent modules",
       "description":"The protocol-dependent modules, used in the EIGRP rout- ing protocol, are responsible for Network layer, protocol-specific requirements that allow multiple protocol support for IP, IPX, and AppleTalk."
    },
    {
       "key":565,
       "value":"protocol stack",
       "description":"A collection of related protocols."
    },
    {
       "key":566,
       "value":"Proxy Address Resolution Protocol",
       "description":"Proxy ARP: Used to allow redundancy in case of a failure with the configured default gateway on a host. Proxy ARP is a variation of the ARP protocol in which an intermediate device, such as a router, sends an ARP response on behalf of an end node to the requesting host."
    },
    {
       "key":567,
       "value":"pruning",
       "description":"The act of trimming down the shortest-path tree. This deactivates interfaces that do not have group participants."
    },
    {
       "key":568,
       "value":"PSE",
       "description":"Packet switching exchange: The X.25 term for a switch."
    },
    {
       "key":569,
       "value":"PSN",
       "description":"Packet-switched network: Any network that uses packet-switching technology. Also known as packet-switched data network (PSDN). See also: packet switching."
    },
    {
       "key":570,
       "value":"PSTN",
       "description":"Public switched telephone network: Colloquially referred to as plain old telephone service (POTS). A term that describes the assortment of telephone networks and services available globally."
    },
    {
       "key":571,
       "value":"PVC",
       "description":"Permanent virtual circuit: In a Frame Relay or ATM network, a logical connection, defined in software, that is maintained permanently. Compare with: SVC. See also: virtual circuit (VC)."
    },
    {
       "key":572,
       "value":"PVP",
       "description":"Permanent virtual path: A virtual path made up of PVCs. See also: PVC."
    },
    {
       "key":573,
       "value":"PVP",
       "description":"tunneling Permanent virtual path tunneling: A technique that links two private ATM networks across a public network using a virtual path, wherein the public network transparently trunks the complete collection of virtual channels in the virtual path between the two private networks."
    },
    {
       "key":574,
       "value":"QoS",
       "description":"Quality of service: A set of metrics used to measure the quality of transmission and service availability of any given transmission system."
    },
    {
       "key":575,
       "value":"queue",
       "description":"Broadly, any list of elements arranged in an orderly fashion and ready for process- ing, such as a line of people waiting to enter a movie theater. In routing, it refers to a back- log of information packets waiting in line to be transmitted over a router interface."
    },
    {
       "key":576,
       "value":"R reference point",
       "description":"Used with ISDN networks to identify the connection between an NT1 and an S/T device. The S/T device converts the four-wire network to the two-wire ISDN standard network. See also: S reference point, T reference point, and U reference point."
    },
    {
       "key":577,
       "value":"RADIUS",
       "description":"Remote Authentication Dial-In User Service: A protocol that is used to commu- nicate between the remote access device and an authentication server. Sometimes an authen- tication server running RADIUS will be called a RADIUS server."
    },
    {
       "key":578,
       "value":"RAM",
       "description":"Random-access memory: Used by all computers to store information. Cisco routers use RAM to store packet buffers and routing tables along with the hardware addresses cache."
    },
    {
       "key":579,
       "value":"RARP",
       "description":"Reverse Address Resolution Protocol: The protocol within the TCP/IP stack that maps MAC addresses to IP addresses. See also: ARP."
    },
    {
       "key":580,
       "value":"RARP server",
       "description":"A Reverse Address Resolution Protocol server is used to provide an IP address from a known MAC address."
    },
    {
       "key":581,
       "value":"rate queue",
       "description":"A value, assigned to one or more virtual circuits, that specifies the speed at which an individual virtual circuit will transmit data to the remote end. Every rate queue identifies a segment of the total bandwidth available on an ATM link. The sum of all rate queues should not exceed the total available bandwidth."
    },
    {
       "key":582,
       "value":"RCP",
       "description":"Remote Copy Protocol: A protocol for copying files to or from a file system that resides on a remote server on a network. Uses TCP to guarantee reliable data delivery."
    },
    {
       "key":583,
       "value":"redundancy",
       "description":"In internetworking, the duplication of connections, devices, or services that can be used as a backup in the event that the primary connections, devices, or services fail."
    },
    {
       "key":584,
       "value":"reference model",
       "description":"Used by application developers to create applications that work on any type of network. The most popular reference model is the Open Systems Interconnection (OSI) model."
    },
    {
       "key":585,
       "value":"reliability",
       "description":"EIGRP uses only bandwidth and delay of the line to determine the best path to a remote network by default. A metric EIGRP uses, in combination with bandwidth, delay, and load to find the best path to a remote network. Reliability refers to the reliability of the link to each remote network."
    },
    {
       "key":586,
       "value":"reliable multicast",
       "description":"When EIGRP sends multicast traffic, it uses the Class D address 224.0.0.10. Each EIGRP router is aware of who its neighbors are, and for each multicast it sends out, it maintains a list of the neighbors who have replied. If EIGRP doesn\u0027t get a reply from a neighbor, it will switch to using unicasts to resend the same data. If it still doesn\u0027t get a reply after 16 unicast attempts, the neighbor is declared dead."
    },
    {
       "key":587,
       "value":"Reliable Transport Protocol (RTP)",
       "description":"The Reliable Transport Protocol, used in the EIGRP rout- ing protocol, is responsible for guaranteed, ordered delivery of EIGRP packets to all neighbors."
    },
    {
       "key":588,
       "value":"reload",
       "description":"An event or command that causes Cisco routers to reboot."
    },
    {
       "key":589,
       "value":"RIF",
       "description":"Routing information field: In source-route bridging, a header field that defines the path direction of the frame or token. If the Route Information Indicator (RII) bit is not set, the RIF is read from source to destination (left to right). If the RII bit is set, the RIF is read from the destination back to the source, so the RIF is read right to left. It is defined as part of the token ring frame header for source-routed frames, which contains path information."
    },
    {
       "key":590,
       "value":"ring",
       "description":"Two or more stations connected in a logical circular topology. In this topology, which is the basis for Token Ring, FDDI, and CDDI, information is transferred from station to station in sequence."
    },
    {
       "key":591,
       "value":"ring topology",
       "description":"A network logical topology comprising a series of repeaters that form one closed loop by connecting unidirectional transmission links. Individual stations on the net- work are connected to the network at a repeater. Physically, ring topologies are generally organized in a closed-loop star. Compare with: bus topology and star topology."
    },
    {
       "key":592,
       "value":"RIP",
       "description":"Routing Information Protocol: The most commonly used interior gateway protocol in the Internet. RIP employs hop count as a routing metric. See also: Enhanced IGRP, IGP, OSPF, and hop count."
    },
    {
       "key":593,
       "value":"RJ connector",
       "description":"Registered jack connector: Used with twisted-pair wiring to connect the copper wire to network interface cards, switches, and hubs."
    },
    {
       "key":594,
       "value":"rolled cable",
       "description":"Type of wiring cable that is used to connect a PC\u0027s COM port to a router or switch console port."
    },
    {
       "key":595,
       "value":"ROM",
       "description":"Read-only memory: Chip used in computers to help boot the device. Cisco routers use a ROM chip to load the bootstrap, which runs a power-on self-test, and then find and load the IOS in flash memory by default."
    },
    {
       "key":596,
       "value":"root bridge",
       "description":"Used with Spanning Tree Protocol to stop network loops from occurring. The root bridge is elected by having the lowest bridge ID. The bridge ID is determined by the pri- ority (32,768 by default on all bridges and switches) and the main hardware address of the device."
    },
    {
       "key":597,
       "value":"route flap",
       "description":"A route that is being announced in an up/down fashion."
    },
    {
       "key":598,
       "value":"route poisoning",
       "description":"Used by various DV routing protocols to overcome large routing loops and offer explicit information about when a subnet or network is not accessible (instead of merely suggesting that the network is unreachable by not including it in updates). Typically, this is accomplished by setting the hop count to one more than maximum. See also: poison reverse updates."
    },
    {
       "key":599,
       "value":"route summarization",
       "description":"In various routing protocols, such as OSPF, EIGRP, and IS-IS, the consolidation of publicized subnetwork addresses so that a single summary route is adver- tised to other areas by an area border router."
    },
    {
       "key":600,
       "value":"routed protocol",
       "description":"Routed protocols (such as IP and IPX) are used to transmit user data through an internetwork. By contrast, routing protocols (such as RIP, IGRP, and OSPF) are used to update routing tables between routers."
    },
    {
       "key":601,
       "value":"router",
       "description":"A Network layer mechanism, either software or hardware, using one or more met- rics to decide on the best path to use for transmission of network traffic. Sending packets between networks by routers is based on the information provided on Network layers. His- torically, this device has sometimes been called a gateway."
    },
    {
       "key":602,
       "value":"router ID (RID)",
       "description":"The router ID (RID) is an IP address used to identify the router. Cisco chooses the router ID by using the highest IP address of all configured loopback interfaces. If no loopback interfaces are configured with addresses, OSPF will choose the highest IP address of all active physical interfaces."
    },
    {
       "key":603,
       "value":"routing",
       "description":"The process of forwarding logically addressed packets from their local subnet- work toward their ultimate destination. In large networks, the numerous intermediary destinations a packet might travel before reaching its destination can make routing very complex."
    },
    {
       "key":604,
       "value":"routing domain",
       "description":"Any collection of end systems and intermediate systems that operate under an identical set of administrative rules. Every routing domain contains one or several areas, all individually given a certain area address."
    },
    {
       "key":605,
       "value":"routing metric",
       "description":"Any value that is used by routing algorithms to determine whether one route is superior to another. Metrics include such information as bandwidth, delay, hop count, path cost, load, MTU, reliability, and communications cost. Only the best possible routes are stored in the routing table, while all other information may be stored in link-state or topological databases. See also: cost."
    },
    {
       "key":606,
       "value":"routing protocol",
       "description":"Any protocol that defines algorithms to be used for updating routing tables between routers. Examples include IGRP, RIP, and OSPF."
    },
    {
       "key":607,
       "value":"routing table",
       "description":"A table kept in a router or other internetworking mechanism that maintains a record of only the best possible routes to certain network destinations and the metrics associated with those routes."
    },
    {
       "key":608,
       "value":"RP",
       "description":"Route processor: Also known as a supervisory processor; a module on Cisco 7000 series routers that holds the CPU, system software, and most of the memory components used in the router."
    },
    {
       "key":609,
       "value":"RSP",
       "description":"Route/switch processor: A processor module combining the functions of RP and SP used in Cisco 7500 series routers. See also: RP and SP."
    },
    {
       "key":610,
       "value":"RTS",
       "description":"Request To Send: An EIA/TIA-232 control signal requesting permission to transmit data on a communication line."
    },
    {
       "key":611,
       "value":"S reference point",
       "description":"ISDN reference point that works with a T reference point to convert a four-wire ISDN network to the two-wire ISDN network needed to communicate with the ISDN switches at the network provider. See also: R reference point, T reference point, and U reference point."
    },
    {
       "key":612,
       "value":"sampling rate",
       "description":"The rate at which samples of a specific waveform amplitude are collected within a specified period of time."
    },
    {
       "key":613,
       "value":"SAP",
       "description":"(1) Service access point: A field specified by IEEE 802.2 that is part of an address specification. (2) Service Advertising Protocol: The Novell NetWare protocol that supplies a way, using routers and servers, to inform network clients of resources and services availabil- ity on a network, using routers and servers. See also: IPX."
    },
    {
       "key":614,
       "value":"SCR",
       "description":"Sustainable cell rate: An ATM Forum parameter used for traffic management, it is the long-term average cell rate for VBR connections that can be transmitted."
    },
    {
       "key":615,
       "value":"SDH",
       "description":"Synchronous Digital Hierarchy: One of the standards developed for Fiber Optics Transmission Systems (FOTS)."
    },
    {
       "key":616,
       "value":"SDLC",
       "description":"Synchronous Data Link Control: A protocol used in SNA Data Link layer com- munications. SDLC is a bit-oriented, full-duplex serial protocol that is the basis for several similar protocols, including HDLC and LAPB. See also: HDLC and LAPB."
    },
    {
       "key":617,
       "value":"seed router",
       "description":"In an AppleTalk network, the router that is equipped with the network num- ber or cable range in its port descriptor. The seed router specifies the network number or cable range for other routers in that network section and answers to configuration requests from nonseed routers on its connected AppleTalk network, permitting those routers to affirm or modify their configurations accordingly. Every AppleTalk network needs at least one seed router physically connected to each network segment."
    },
    {
       "key":618,
       "value":"sequencing",
       "description":"Used in virtual circuits and segmentation to number segments so they can be put back together again in the correct order."
    },
    {
       "key":619,
       "value":"serial transmission",
       "description":"WAN serial connectors use serial transmission, which takes place one bit at a time, over a single channel."
    },
    {
       "key":620,
       "value":"server",
       "description":"Hardware and software that provide network services to clients."
    },
    {
       "key":621,
       "value":"Session layer",
       "description":"Layer 5 of the OSI reference model, responsible for creating, managing, and terminating sessions between applications and overseeing data exchange between Presenta- tion layer entities. See also: Application layer, Data Link layer, Network layer, Physical layer, Presentation layer, and Transport layer."
    },
    {
       "key":622,
       "value":"set-based",
       "description":"Set-based routers and switches use the set command to configure devices. Cisco is moving away from set-based commands and is using the command-line interface (CLI) on all new devices."
    },
    {
       "key":623,
       "value":"setup mode",
       "description":"Mode that a router will enter if no configuration is found in nonvolatile RAM when the router boots. Allows the administrator to configure a router step-by-step. Not as robust or flexible as the command-line interface."
    },
    {
       "key":624,
       "value":"SF",
       "description":"A Superframe (also called a D4 frame) consists of 12 frames with 192 bits each, and the 193rd bit provides other functions, including error checking. SF is frequently used on T1 circuits. A newer version of the technology is Extended Super Frame (ESF), which uses 24 frames. See also: ESF."
    },
    {
       "key":625,
       "value":"shared tree",
       "description":"A method of multicast data forwarding. Shared trees use an architecture in which multiple sources share a common rendezvous point."
    },
    {
       "key":626,
       "value":"shortest path first (SPF)",
       "description":"A type of routing algorithm. The only true SPF protocol is Open Shortest Path First (OSPF)."
    },
    {
       "key":627,
       "value":"signaling packet",
       "description":"An informational packet created by an ATM-connected mechanism that wants to establish connection with another such mechanism. The packet contains the QoS parameters needed for connection and the ATM NSAP address of the endpoint. The end- point responds with a message of acceptance if it is able to support the desired QoS, and the connection is established. See also: QoS."
    },
    {
       "key":628,
       "value":"silicon switching",
       "description":"A type of high-speed switching used in Cisco 7000 series routers, based on the use of a separate processor (the Silicon Switch Processor, or SSP). See also: SSE."
    },
    {
       "key":629,
       "value":"simplex",
       "description":"A mode at which data or a digital signal is transmitted. Simplex is a way of trans- mitting in only one direction. Half-duplex transmits in two directions but only one direc- tion at a time. Full-duplex transmits in both directions simultaneously."
    },
    {
       "key":630,
       "value":"sliding window",
       "description":"The method of flow control used by TCP as well as several Data Link layer protocols. This method places a buffer between the receiving application and the net- work data flow. The \u0027window\u0027 available for accepting data is the size of the buffer minus the amount of data already there. This window increases in size as the application reads data from it and decreases as new data is sent. The receiver sends the transmitter announce- ments of the current window size, and it may stop accepting data until the window increases above a certain threshold."
    },
    {
       "key":631,
       "value":"SLIP",
       "description":"Serial Line Internet Protocol: An industry-standard serial encapsulation for point-to- point connections that supports only a single routed protocol, TCP/IP. SLIP is the predecessor to PPP. See also: PPP."
    },
    {
       "key":632,
       "value":"SMDS",
       "description":"Switched Multimegabit Data Service: A packet-switched, datagram-based WAN networking technology offered by telephone companies that provides high speed."
    },
    {
       "key":633,
       "value":"SMTP",
       "description":"Simple Mail Transfer Protocol: A protocol used on the Internet to provide electronic mail services."
    },
    {
       "key":634,
       "value":"SNA",
       "description":"Systems Network Architecture: A complex, feature-rich, network architecture simi- lar to the OSI reference model but with several variations; created by IBM in the 1970s and essentially composed of seven layers."
    },
    {
       "key":635,
       "value":"SNAP",
       "description":"Subnetwork Access Protocol: SNAP is a frame used in Ethernet, Token Ring, and FDDI LANs. Data transfer, connection management, and QoS selection are three primary functions executed by the SNAP frame."
    },
    {
       "key":636,
       "value":"snapshot routing",
       "description":"Snapshot routing takes a point-in-time capture of a dynamic routing table and maintains it even when the remote connection goes down. This allows the use of a dynamic routing protocol without requiring the link to remain active, which might incur per-minute usage charges."
    },
    {
       "key":637,
       "value":"SNMP",
       "description":"Simple Network Management Protocol: This protocol polls SNMP agents or devices for statistical and environmental data. This data can include device temperature, name, performance statistics, and much more. SNMP works with MIB objects that are present on the SNMP agent. This information is queried, then sent to the SNMP server."
    },
    {
       "key":638,
       "value":"socket",
       "description":"(1) A software structure that operates within a network device as a destination point for communications. (2) In AppleTalk networks, an entity at a specific location within a node. AppleTalk sockets are conceptually similar to TCP/IP ports."
    },
    {
       "key":639,
       "value":"software address",
       "description":"Also called a logical address. This is typically an IP address, but it can also be an IPX address."
    },
    {
       "key":640,
       "value":"SOHO",
       "description":"Small office/home office: A contemporary term for remote users at home or at a small remote location."
    },
    {
       "key":641,
       "value":"SONET",
       "description":"Synchronous Optical Network: The ANSI standard for synchronous transmission on fiber-optic media, developed at Bell Labs. It specifies a base signal rate of 51.84 Mbps and a set of multiples of that rate, known as Optical Carrier levels, up to 2.5 Gbps."
    },
    {
       "key":642,
       "value":"source tree",
       "description":"A method of multicast data forwarding. Source trees use the architecture of the source of the multicast traffic as the root of the tree."
    },
    {
       "key":643,
       "value":"SP",
       "description":"Switch processor: Also known as a ciscoBus controller, it is a Cisco 7000 series proces- sor module acting as governing agent for all CxBus activities."
    },
    {
       "key":644,
       "value":"span",
       "description":"A full-duplex digital transmission line connecting two facilities."
    },
    {
       "key":645,
       "value":"SPAN",
       "description":"Switched Port Analyzer: A feature of the Catalyst 5000 switch offering freedom to manipulate within a switched Ethernet environment by extending the monitoring ability of the existing network analyzers into the environment. At one switched segment, the SPAN mirrors traffic onto a predetermined SPAN port, while a network analyzer connected to the SPAN port is able to monitor traffic from any other Catalyst switched port."
    },
    {
       "key":646,
       "value":"spanning explorer packet",
       "description":"Sometimes called limited-route or single-route explorer packet, it pursues a statically configured spanning tree when searching for paths in a source-route bridging network. See also: all-routes explorer packet, explorer packet, and local explorer packet."
    },
    {
       "key":647,
       "value":"spanning tree",
       "description":"A subset of a network topology within which no loops exist. When bridges are interconnected into a loop, the bridge, or switch, cannot identify a frame that has been forwarded previously, so there is no mechanism for removing a frame as it passes the inter- face numerous times. Without a method of removing these frames, the bridges continuously forward them—consuming bandwidth and adding overhead to the network. Spanning trees prune the network to provide only one path for any packet. See also: Spanning Tree Proto- col and spanning-tree algorithm."
    },
    {
       "key":648,
       "value":"spanning-tree algorithm (STA)",
       "description":"An algorithm that creates a spanning tree using the Span- ning Tree Protocol (STP). See also: spanning tree and Spanning Tree Protocol."
    },
    {
       "key":649,
       "value":"Spanning Tree Protocol (STP)",
       "description":"The bridge protocol (IEEE 802.1D) that enables a learn- ing bridge to dynamically avoid loops in the network topology by creating a spanning tree using the spanning-tree algorithm. Spanning-tree frames called Bridge Protocol Data Units (BPDUs) are sent and received by all switches in the network at regular intervals. The switches participating in the spanning tree don\u0027t forward the frames; instead, they\u0027re pro- cessed to determine the spanning-tree topology itself. Cisco Catalyst series switches use STP 802.1D to perform this function. See also: BPDU, learning bridge, MAC address, spanning tree, and spanning-tree algorithm."
    },
    {
       "key":650,
       "value":"SPF",
       "description":"Shortest path first: A routing algorithm used to decide on the shortest path. Some- times called Dijkstra\u0027s algorithm and frequently used in link-state routing algorithms. See also: link-state routing algorithm and shortest path first."
    },
    {
       "key":651,
       "value":"SPID",
       "description":"Service Profile Identifier: A number assigned by service providers or local telephone companies and configured by administrators to a BRI port. SPIDs are used to determine subscription services of a device connected via ISDN. ISDN devices use SPID when access- ing the telephone company switch that initializes the link to a service provider."
    },
    {
       "key":652,
       "value":"split horizon",
       "description":"Useful for preventing routing loops, a type of distance-vector routing rule where information about routes is prevented from leaving the router interface through which that information was received."
    },
    {
       "key":653,
       "value":"spoofing",
       "description":"(1) In dial-on-demand routing (DDR), where a circuit-switched link is taken down to save toll charges when there is no traffic to be sent, spoofing is a scheme used by routers that causes a host to treat an interface as if it were functioning and supporting a ses- sion. The router pretends to send \u0027spoof\u0027 replies to keepalive messages from the host in an effort to convince the host that the session is up and running. See also: DDR. (2) The illegal act of sending a packet labeled with a false address in order to deceive network security mechanisms such as filters and access lists."
    },
    {
       "key":654,
       "value":"spooler",
       "description":"A management application that processes requests submitted to it for execution in a sequential fashion from a queue. A good example is a print spooler."
    },
    {
       "key":655,
       "value":"SPX",
       "description":"Sequenced Packet Exchange: A Novell NetWare transport protocol that augments the datagram service provided by Network layer (layer 3) protocols, it was derived from the Switch-to-Switch Protocol of the XNS protocol suite."
    },
    {
       "key":656,
       "value":"SQE",
       "description":"Signal Quality Error: In an Ethernet network, a message sent from a transceiver to an attached machine that the collision-detection circuitry is working."
    },
    {
       "key":657,
       "value":"SRB",
       "description":"Source-route bridging: Created by IBM, the bridging method used in Token Ring networks. The source determines the entire route to a destination before sending the data and includes that information in routing information fields (RIFs) within each packet. Contrast with: transparent bridging."
    },
    {
       "key":658,
       "value":"SRT",
       "description":"Source-route transparent bridging: A bridging scheme developed by IBM and merg- ing source-route and transparent bridging. SRT takes advantage of both technologies in one device, fulfilling the needs of all end nodes. Translation between bridging protocols is not necessary. Compare with: SR/TLB."
    },
    {
       "key":659,
       "value":"SR/TLB",
       "description":"Source-route translational bridging: A bridging method that allows source-route stations to communicate with transparent bridge stations aided by an intermediate bridge that translates between the two bridge protocols. Used for bridging between Token Ring and Ethernet. Compare with: SRT."
    },
    {
       "key":660,
       "value":"SSAP",
       "description":"Source service access point: The SAP of the network node identified in the Source field of the packet the SSAP identifies the Network layer protocol. See also: DSAP and SAP."
    },
    {
       "key":661,
       "value":"SSE",
       "description":"Silicon Switching Engine: The software component of Cisco\u0027s silicon switching tech- nology, hard-coded into the Silicon Switch Processor (SSP). Silicon switching is available only on the Cisco 7000 with an SSP. Silicon-switched packets are compared to the silicon- switching cache on the SSE. The SSP is a dedicated switch processor that offloads the switching process from the route processor, providing a fast-switching solution, but packets must still traverse the backplane of the router to get to the SSP and then back to the exit interface."
    },
    {
       "key":662,
       "value":"standard IP access list",
       "description":"IP access list that uses only the source IP addresses to filter a network."
    },
    {
       "key":663,
       "value":"standard IPX access list",
       "description":"IPX access list that uses only the source and destination IPX address to filter a network."
    },
    {
       "key":664,
       "value":"star topology",
       "description":"A LAN physical topology with endpoints on the network converging at a common central device (known as a hub) using point-to-point links. A logical ring topology can be configured as a physical star topology using a unidirectional closed-loop star rather than point-to-point links. That is, connections within the hub are arranged in an internal ring. See also: bus topology and ring topology."
    },
    {
       "key":665,
       "value":"startup range",
       "description":"If an AppleTalk node does not have a number saved from the last time it was booted, then the node selects from the range of values from 65,280 to 65,534."
    },
    {
       "key":666,
       "value":"state transitions",
       "description":"Digital signaling scheme that reads the \u0027state\u0027 of the digital signal in the middle of the bit cell. If it is five volts, the cell is read as a one. If the state of the digital signal is zero volts, the bit cell is read as a zero."
    },
    {
       "key":667,
       "value":"static route",
       "description":"A route whose information is purposefully entered into the routing table by an administrator and takes priority over those chosen by dynamic routing protocols."
    },
    {
       "key":668,
       "value":"static VLAN",
       "description":"A VLAN that is manually configured port by port. This is the method typically used in production networks."
    },
    {
       "key":669,
       "value":"statistical multiplexing",
       "description":"Multiplexing in general is a technique that allows data from multiple logical channels to be sent across a single physical channel. Statistical multiplexing dynamically assigns bandwidth only to input channels that are active, optimizing available bandwidth so that more devices can be connected than with other multiplexing techniques. Also known as statistical time-division multiplexing or stat mux."
    },
    {
       "key":670,
       "value":"STM-1",
       "description":"Synchronous Transport Module Level 1. In the European SDH standard, one of many formats identifying the frame structure for the 155.52 Mbps lines that are used to carry ATM cells."
    },
    {
       "key":671,
       "value":"store-and-forward packet switching",
       "description":"A technique in which the switch first copies each packet into its buffer and performs a cyclic redundancy check (CRC). If the packet is error free, the switch then looks up the destination address in its filter table, determines the appropriate exit port, and sends the packet."
    },
    {
       "key":672,
       "value":"STP",
       "description":"(1) Shielded twisted-pair: A wiring scheme that is used in many network implementa- tions and has a layer of shielded insulation to reduce EMI. (2) Spanning Tree Protocol. See: Spanning Tree Protocol."
    },
    {
       "key":673,
       "value":"straight-through cable",
       "description":"Type of Ethernet cable that connects a host to a switch, a host to a hub, or a router to a switch or hub."
    },
    {
       "key":674,
       "value":"stub area",
       "description":"An OSPF area carrying a default route, intra-area routes, and interarea routes but no external routes. Configuration of virtual links cannot be achieved across a stub area, and stub areas are not allowed to contain an ASBR. See also: non-stub area, ASBR, and OSPF."
    },
    {
       "key":675,
       "value":"stub network",
       "description":"A network having only one connection to a router."
    },
    {
       "key":676,
       "value":"STUN",
       "description":"Serial Tunnel: A technology used to connect an HDLC link to an SDLC link over a serial link."
    },
    {
       "key":677,
       "value":"subarea",
       "description":"A portion of an SNA network made up of a subarea node and its attached links and peripheral nodes."
    },
    {
       "key":678,
       "value":"subarea node",
       "description":"An SNA communications host or controller that handles entire network addresses."
    },
    {
       "key":679,
       "value":"subchannel",
       "description":"A frequency-based subdivision that creates a separate broadband communi- cations channel."
    },
    {
       "key":680,
       "value":"subinterface",
       "description":"One of many virtual interfaces available on a single physical interface."
    },
    {
       "key":681,
       "value":"subnet",
       "description":"(1) Any network that is part of a larger IP network and is identified by a subnet address. A network administrator segments a network into subnetworks in order to provide a hierarchical, multilevel routing structure and at the same time protect the subnetwork from the addressing complexity of networks that are attached. Also known as a subnet. See also: IP address, subnet mask, and subnet address. (2) In OSI networks, the term specifi- cally refers to a collection of ESs and ISs controlled by only one administrative domain using a solitary network connection protocol."
    },
    {
       "key":682,
       "value":"subnet address",
       "description":"The portion of an IP address that is specifically identified by the subnet mask as the subnetwork. See also: IP address, subnetwork, and subnet mask."
    },
    {
       "key":683,
       "value":"subnet mask",
       "description":"Also simply known as a mask, a 32-bit address mask used in IP to identify the bits of an IP address that are used for the subnet address. Using a mask, the router does not need to examine all 32 bits, only those indicated by the mask. See also: address mask and IP address."
    },
    {
       "key":684,
       "value":"subnetting",
       "description":"Used in IP networks to break up larger networks into smaller subnetworks."
    },
    {
       "key":685,
       "value":"subnetwork",
       "description":"See subnet."
    },
    {
       "key":686,
       "value":"summarization",
       "description":"Term used to describe the process of summarizing multiple routing table entries into one entry."
    },
    {
       "key":687,
       "value":"supernetting",
       "description":"See: summarization."
    },
    {
       "key":688,
       "value":"SVC",
       "description":"Switched virtual circuit: A dynamically established virtual circuit created on demand and dissolved as soon as transmission is over and the circuit is no longer needed. In ATM terminology, it is referred to as a switched virtual connection. Compare with: PVC. See also: virtual circuit (VC)."
    },
    {
       "key":689,
       "value":"switch",
       "description":"(1) In networking, a device responsible for multiple functions, such as filtering, flooding, and sending frames. It works using the destination address of individual frames. Switches operate at the Data Link layer of the OSI model. (2) Broadly, any electronic/ mechanical device allowing connections to be established as needed and terminated if no longer necessary."
    },
    {
       "key":690,
       "value":"switch block",
       "description":"A combination of layer 2 switches and layer 3 routers. The layer 2 switches connect users in the wiring closet into the access layer and provide 10 or 100 Mbps dedi- cated connections. 1900/2820 and 2900 Catalyst switches can be used in the switch block."
    },
    {
       "key":691,
       "value":"switch fabric",
       "description":"Term used to identify a layer 2 switched internetwork with many switches. More commonly, it is a term used to identify the inner workings of a switch itself. Thus, it is the matrix of pathways that any frame or cell might be able to traverse as it is switched from input port to output port."
    },
    {
       "key":692,
       "value":"switched LAN",
       "description":"Any LAN implemented using LAN switches. See also: LAN switch."
    },
    {
       "key":693,
       "value":"synchronous transmission",
       "description":"Signals transmitted digitally with precision clocking. These signals have identical frequencies and contain individual characters encapsulated in control bits (called start/stop bits) that designate the beginning and ending of each character. See also: asynchronous transmission and isochronous transmission."
    },
    {
       "key":694,
       "value":"syslog",
       "description":"A protocol used to monitor system log messages by a remote device."
    },
    {
       "key":695,
       "value":"T reference point",
       "description":"Used with an S reference point to change a four-wire ISDN network to a two-wire ISDN network. See also: R reference point, S reference point, and U reference point."
    },
    {
       "key":696,
       "value":"T1",
       "description":"Digital WAN that uses 24 DS0s at 64 Kbps each to create a bandwidth of 1.536 Mbps, minus clocking overhead, providing 1.544 Mbps of usable bandwidth."
    },
    {
       "key":697,
       "value":"T3",
       "description":"Digital WAN that can provide bandwidth of 44.763 Mbps."
    },
    {
       "key":698,
       "value":"TACACS+",
       "description":"Terminal Access Controller Access Control System Plus: An enhanced version of TACACS, this protocol is similar to RADIUS. See also: RADIUS."
    },
    {
       "key":699,
       "value":"tagged traffic",
       "description":"ATM cells with their cell loss priority (CLP) bit set to 1. Also referred to as Discard Eligible (DE) traffic in Frame Relay networks. Tagged traffic can be eliminated in order to ensure trouble-free delivery of higher-priority traffic if the network is congested. See also: CLP."
    },
    {
       "key":700,
       "value":"TCP",
       "description":"Transmission Control Protocol: A connection-oriented protocol that is defined at the Transport layer of the OSI reference model. Provides reliable delivery of data."
    },
    {
       "key":701,
       "value":"TCP/IP",
       "description":"Transmission Control Protocol/Internet Protocol. The suite of protocols underly- ing the Internet. TCP and IP are the most widely known protocols in that suite. See also: IP and TCP."
    },
    {
       "key":702,
       "value":"TDM",
       "description":"Time division multiplexing: A technique for assigning bandwidth on a single wire, based on preassigned time slots, to data from several channels. Bandwidth is allotted to each channel regardless of a station\u0027s intent to send data. See also: ATDM, FDM, and mul- tiplexing."
    },
    {
       "key":703,
       "value":"TE",
       "description":"Terminal equipment: Any peripheral device that is ISDN compatible and attached to a network, such as a telephone or computer. TE1s are devices that are ISDN-ready and under- stand ISDN signaling techniques. TE2s are devices that are not ISDN-ready and do not understand ISDN signaling techniques. A terminal adapter must be used with a TE2."
    },
    {
       "key":704,
       "value":"TE1",
       "description":"Terminal equipment type 1: A device with a four-wire, twisted-pair digital interface is referred to as terminal equipment type 1. Most modern ISDN devices are of this type."
    },
    {
       "key":705,
       "value":"TE2",
       "description":"Terminal equipment type 2: Devices known as terminal equipment type 2 do not under- stand ISDN signaling techniques, and a terminal adapter must be used to convert the signaling."
    },
    {
       "key":706,
       "value":"telco",
       "description":"A common abbreviation for the telephone company."
    },
    {
       "key":707,
       "value":"Telnet",
       "description":"The standard terminal emulation protocol within the TCP/IP protocol stack. Method of remote terminal connection, enabling users to log in on remote networks and use the resources as if they were locally connected. Telnet is defined in RFC 854."
    },
    {
       "key":708,
       "value":"terminal adapter (TA)",
       "description":"A hardware interface between a computer without a native ISDN interface and an ISDN line. In effect, a device to connect a standard async interface to a non-native ISDN device, emulating a modem."
    },
    {
       "key":709,
       "value":"terminal emulation",
       "description":"The use of software, installed on a PC or LAN server, that allows the PC to function as if it were a \u0027dumb\u0027 terminal directly attached to a particular type of mainframe."
    },
    {
       "key":710,
       "value":"TFTP",
       "description":"Trivial File Transfer Protocol: Conceptually, a stripped-down version of FTP; it\u0027s the protocol of choice if you know exactly what you want and where it\u0027s to be found. TFTP doesn\u0027t provide the abundance of functions that FTP does. In particular, it has no directory browsing abilities; it can do nothing but send and receive files."
    },
    {
       "key":711,
       "value":"TFTP host/server",
       "description":"A host or server on which Trivial File Transfer Protocol is used to send files using IP at the Network layer and UDP at the Transport layer, which makes it unreliable."
    },
    {
       "key":712,
       "value":"thicknet",
       "description":"Also called 10Base-5. Bus network that uses a thick coaxial cable and runs Ethernet up to 500 meters."
    },
    {
       "key":713,
       "value":"thinnet",
       "description":"Also called 10Base-2. Bus network that uses a thin coaxial cable and runs Ethernet media access up to 185 meters."
    },
    {
       "key":714,
       "value":"three-way handshake",
       "description":"Term used in a TCP session to define how a virtual circuit is set up. It is called a three-way handshake because it uses three data segments."
    },
    {
       "key":715,
       "value":"token",
       "description":"A frame containing only control information. Possessing this control informa- tion gives a network device permission to transmit data onto the network. See also: token passing."
    },
    {
       "key":716,
       "value":"token bus",
       "description":"LAN architecture that is the basis for the IEEE 802.4 LAN specification and employs token-passing access over a bus topology. See also: IEEE."
    },
    {
       "key":717,
       "value":"token passing",
       "description":"A method used by network devices to access the physical medium in a sys- tematic way based on possession of a small frame called a token. See also: token."
    },
    {
       "key":718,
       "value":"Token Ring",
       "description":"IBM\u0027s token-passing LAN technology. It runs at 4 Mbps or 16 Mbps over a ring topology. Defined formally by IEEE 802.5. See also: ring topology and token passing."
    },
    {
       "key":719,
       "value":"toll network",
       "description":"WAN network that uses the public switched telephone network (PSTN) to send packets."
    },
    {
       "key":720,
       "value":"topology database",
       "description":"A topology database (also called a topology table) contains all des- tinations advertised by neighboring routers. Associated with each entry is the destination address and a list of neighbors that have advertised the destination."
    },
    {
       "key":721,
       "value":"Traceroute",
       "description":"Also Trace; IP command used to trace the path a packet takes through an internetwork."
    },
    {
       "key":722,
       "value":"transparent bridging",
       "description":"The bridging scheme used in Ethernet and IEEE 802.3 networks, it passes frames along one hop at a time using bridging information stored in tables that asso- ciate end-node MAC addresses with bridge ports. This type of bridging is considered trans- parent because the source node does not know it has been bridged because the destination frames are addressed directly to the end node. Contrast with: SRB."
    },
    {
       "key":723,
       "value":"Transport layer",
       "description":"Layer 4 of the OSI reference model, used for reliable communication between end nodes over the network. The Transport layer provides mechanisms used for establishing, maintaining, and terminating virtual circuits; transport fault detection and recovery; and controlling the flow of information. See also: Application layer, Data Link layer, Network layer, Physical layer, Presentation layer, and Session layer."
    },
    {
       "key":724,
       "value":"trap",
       "description":"Used to send SNMP messages to SNMP managers."
    },
    {
       "key":725,
       "value":"TRIP",
       "description":"Token Ring Interface Processor: A high-speed interface processor used on Cisco 7000 series routers. The TRIP provides two or four ports for interconnection with IEEE 802.5 and IBM media with ports set to speeds of either 4 Mbps or 16 Mbps, set indepen- dently of each other."
    },
    {
       "key":726,
       "value":"trunk link",
       "description":"Link used between switches and from some servers to the switches. Trunk links carry traffic for many VLANs. Access links are used to connect host devices to a switch and carry only VLAN information that the device is a member of."
    },
    {
       "key":727,
       "value":"TTL",
       "description":"Time to live: A field in an IP header, indicating the length of time a packet is valid."
    },
    {
       "key":728,
       "value":"TUD",
       "description":"Trunk Up-Down: A protocol used in ATM networks for the monitoring of trunks. Should a trunk miss a given number of test messages being sent by ATM switches to ensure trunk line quality, TUD declares the trunk down. When a trunk reverses state and comes back up, TUD recognizes that the trunk is up and returns the trunk to service."
    },
    {
       "key":729,
       "value":"tunneling",
       "description":"A method of avoiding protocol restrictions by wrapping packets from one pro- tocol in another protocol\u0027s frame and transmitting this encapsulated packet over a network that supports the wrapper protocol. See also: encapsulation."
    },
    {
       "key":730,
       "value":"U reference point",
       "description":"Reference point between a TE1 and an ISDN network. The U reference point understands ISDN signaling techniques and uses a two-wire connection. See also: R reference point, S reference point, and T reference point."
    },
    {
       "key":731,
       "value":"UDP",
       "description":"User Datagram Protocol: A connectionless Transport layer protocol in the TCP/IP protocol stack that simply allows datagrams to be exchanged without acknowledgments or delivery guarantees, requiring other protocols to handle error processing and retransmis- sion. UDP is defined in RFC 768."
    },
    {
       "key":732,
       "value":"unicast",
       "description":"Used for direct host-to-host communication. Communication is directed to only one destination and is originated only from one source."
    },
    {
       "key":733,
       "value":"unidirectional shared tree",
       "description":"A method of shared tree multicast forwarding. This method allows only multicast data to be forwarded from the RP."
    },
    {
       "key":734,
       "value":"unique local addresses (FC00::/7)",
       "description":"These addresses are also intended for nonrouting pur- poses over the Internet. Unique local addresses were designed to replace site-local addresses, so they basically do almost exactly what IPv4 private addresses do. See also: global unicast addresses and link-local addresses."
    },
    {
       "key":735,
       "value":"unnumbered frames",
       "description":"HDLC frames used for control-management purposes, such as link startup and shutdown or mode specification."
    },
    {
       "key":736,
       "value":"user mode",
       "description":"Cisco IOS EXEC mode that allows an administrator to perform very few com- mands. You can only verify statistics in user mode; you cannot see or change the router or switch configuration."
    },
    {
       "key":737,
       "value":"UTP",
       "description":"Unshielded twisted-pair: Copper wiring used in small to large networks to connect host devices to hubs and switches. Also used to connect switch to switch or hub to hub."
    },
    {
       "key":738,
       "value":"VBR",
       "description":"Variable bit rate: A QoS class, as defined by the ATM Forum, for use in ATM net- works that is subdivided into real time (RT) class and non–real time (NRT) class. RT is employed when connections have a fixed-time relationship between samples. Conversely, NRT is employed when connections do not have a fixed-time relationship between samples but still need an assured QoS."
    },
    {
       "key":739,
       "value":"VCC",
       "description":"Virtual channel connection: A logical circuit that is created by VCLs (virtual channel links). VCCs carry data between two endpoints in an ATM network. Sometimes called a virtual circuit connection."
    },
    {
       "key":740,
       "value":"VIP",
       "description":"(1) Versatile Interface Processor: An interface card for Cisco 7000 and 7500 series routers, providing multilayer switching and running the Cisco IOS software. The most recent version of VIP is VIP2. (2) Virtual IP: A function making it possible for logically separated switched IP workgroups to run Virtual Networking Services across the switch port."
    },
    {
       "key":741,
       "value":"virtual circuit (VC)",
       "description":"A logical circuit devised to assure reliable communication between two devices on a network. Defined by a virtual path identifier/virtual channel (really only the time \u0027channel\u0027 is used) identifier (VPI/VCI) pair, a virtual circuit can be permanent (PVC) or switched (SVC). Virtual circuits are used in Frame Relay and X.25. Known as vir- tual channel in ATM. See also: PVC and SVC."
    },
    {
       "key":742,
       "value":"virtual ring",
       "description":"In an SRB network, a logical connection between physical rings, either local or remote."
    },
    {
       "key":743,
       "value":"VLAN",
       "description":"Virtual LAN: A group of devices on one or more logically segmented LANs (con- figured by use of management software), enabling devices to communicate as if attached to the same physical medium when they are actually located on numerous different LAN segments. VLANs are based on logical instead of physical connections and thus are tremen- dously flexible."
    },
    {
       "key":744,
       "value":"VLAN ID",
       "description":"Sometimes referred to as VLAN color, the VLAN ID is tagged onto a frame to tell a receiving switch which VLAN the frame is a member of."
    },
    {
       "key":745,
       "value":"VLSM",
       "description":"Variable length subnet mask: Helps optimize available address space and specify a different subnet mask for the same network number on various subnets. Also commonly referred to as \u0027subnetting a subnet.\u0027"
    },
    {
       "key":746,
       "value":"VMPS",
       "description":"VLAN Management Policy Server: Used to dynamically assign VLANs to a switch port."
    },
    {
       "key":747,
       "value":"VPN",
       "description":"Virtual private network: A method of encrypting point-to-point logical connections across a public network, such as the Internet. This allows secure communications across a public network."
    },
    {
       "key":748,
       "value":"VTP",
       "description":"VLAN Trunking Protocol: Used to update switches in a switch fabric with informa- tion about VLANs configured on a VTP server. VTP devices can be a VTP server, client, or transparent device. Servers update clients. Transparent devices are only local devices and do not share information with VTP clients. VTP devices send VLAN information down trunked links only."
    },
    {
       "key":749,
       "value":"VTP transparent mode",
       "description":"Switch mode that receives VLAN Trunking Protocol VLAN information and passes it on but doesn\u0027t read the information."
    },
    {
       "key":750,
       "value":"WAN",
       "description":"Wide area network: A designation used to connect LANs together across a DCE (data communication equipment) network. Typically, a WAN is a leased line or dial-up connection across a PSTN network. Examples of WAN protocols include Frame Relay, PPP, ISDN, and HDLC."
    },
    {
       "key":751,
       "value":"wildcard",
       "description":"Used with access lists and OSPF configurations. Wildcards are designations used to identify a range of subnets."
    },
    {
       "key":752,
       "value":"windowing",
       "description":"Flow-control method used with TCP at the Transport layer of the OSI model."
    },
    {
       "key":753,
       "value":"WINS",
       "description":"Windows Internet Name Service: Name resolution database for NetBIOS names to TCP/IP address."
    },
    {
       "key":754,
       "value":"WinSock",
       "description":"Windows Socket Interface: A software interface that makes it possible for an assortment of applications to use and share an Internet connection. The WinSock software consists of a dynamic link library (DLL) with supporting programs such as a dialer program that initiates the connection."
    },
    {
       "key":755,
       "value":"workgroup layer",
       "description":"The distribution layer of the Cisco hierarchical model is sometimes referred to as the workgroup layer and is the communication point between the access layer and the core. The primary functions of the distribution layer are to provide routing, filter- ing, and WAN access and to determine how packets can access the core, if needed."
    },
    {
       "key":756,
       "value":"workgroup switching",
       "description":"A switching method that supplies high-speed (100 Mbps) trans- parent bridging between Ethernet networks as well as high-speed translational bridging between Ethernet and CDDI or FDDI."
    },
    {
       "key":757,
       "value":"X Window",
       "description":"A distributed multitasking windowing and graphics system originally developed by MIT for communication between X terminals and Unix workstations."
    },
    {
       "key":758,
       "value":"X.25",
       "description":"An ITU-T packet-relay standard that defines communication between DTE and DCE network devices. X.25 uses a reliable Data Link layer protocol called LAPB. X.25 also uses PLP at the Network layer. X.25 has mostly been replaced by Frame Relay."
    },
    {
       "key":759,
       "value":"ZIP",
       "description":"Zone Information Protocol: A Session layer protocol used by AppleTalk to map net- work numbers to zone names. NBP uses ZIP in the determination of networks containing nodes that belong to a zone. See also: ZIP storm and zone."
    },
    {
       "key":760,
       "value":"ZIP storm",
       "description":"A broadcast storm occurring when a router running AppleTalk reproduces or transmits a route for which there is no corresponding zone name at the time of execution. The route is then forwarded by other routers downstream, thus causing a ZIP storm. See also: broadcast storm and ZIP."
    },
    {
       "key":761,
       "value":"zone",
       "description":"A logical grouping of network devices in AppleTalk. Also used in DNS. See also: ZIP."
    }
  ]